import React, { useState, useEffect, useRef } from 'react';
import {
  getSingleRunningVehicle,
  createServiceRemainder,
  getServiceRemainder,
  getSingleServiceRemainder,
  editServiceRemainder,
  deleteServiceRemainder,
  createBreakdown,
  getBreakdown,
  getSingleBreakdown,
  editBreakdown,
  deleteBreakdown,
  createSpare,
  getSpare,
  getSingleSpare,
  editSpare,
  deleteSpare,
  createSpareRequest,
  getSpareRequest,
  getSingleSpareRequest,
  editSpareRequestMethod,
  deleteSpareRequest,
  createResellScrap,
  getSingleResellScrap,
  approveSpareRequest,
  getFullRunningVehicleReport,
  createAfterVehicleRequest,
  createAfterPurchaseOrder,
  getFullRunningVehicleReportOne,
  getFullRunningVehicleReportTwo,
  transferingVehicle,
  editRemainder,
  createRemainder,
  getRemainder,
  getSingleRemainder,
  deleteRemainder,
  createDocument,
  getDocument,
  getSingleDocument,
  editDocument,
  deleteDocument,
  getSingleServiceInfo,
} from '../../services/vm/apiController';
import { Link, useParams, useNavigate, useLocation } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import { Table, Row, Modal, Button, Form, FloatingLabel, Tabs, Tab, Col, Alert } from 'react-bootstrap';
import { formatDate, totalKmsSubtract } from '../../util/helper';
import { DeleteIcon, DownloadIcon, EditIcon, ViewIcon } from './components/icons';
import { TABLE_DEFAULT_LIMIT } from '../../util/constant';
import moment from 'moment';
import AlertIcon from '../../img.svg';
import { useSelector } from 'react-redux';
import PaginationInPage from '../Pagination';

const RunningVehicleDetail = () => {
  let params = useParams();
  const navigate = useNavigate();
  const [runngingVehicleDetail, setRunngingVehicleDetail] = useState('');
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [showServiceRemainderModal, setShowServiceRemainderModal] = useState(false);
  const [showRemainderModal, setShowRemainderModal] = useState(false);
  const [showDocumentModal, setShowDocumentModal] = useState(false);
  const [showBreakdownModal, setShowBreakdownModal] = useState(false);
  const [showSpareModal, setShowSpareModal] = useState(false);
  const [showSpareRequestModal, setShowSpareRequestModal] = useState(false);
  const [showResellScrapModal, setShowResellScrapModal] = useState(false);
  const [showSpareRequestApproveModal, setShowSpareRequestApproveModal] = useState(false);
  const [validated, setValidated] = useState(false);
  const formFields = {
    serviceName: '',
    description: '',
    dueDate: '',
    serviceType: '',
    serviceStatus: '',
    lServiceDate: '',
    lastServiceKm: '',
    currentKm: '',
    totalKm: '',
    labourCost: '',
    totalCost: '',
    showroomName: '',
    showroomAddress: '',
    sContactNo: '',
    servicedDate: '',
    serviceComments: '',
    mCost: '',
    supervisedBy: '',
    document1: null,
    documentName1: '',
    document2: null,
    documentName2: '',
    document3: null,
    documentName3: '',
    document4: null,
    documentName4: '',
  };
  const remainderFields = {
    docType: '',
    description: '',
    dueDate: '',
    status: '',
    supervisedBy: '',
    completedDate: '',
    totalCost: '',
    document1: null,
    documentName1: '',
    document2: null,
    documentName2: '',
  };
  const breakdownFormFields = {
    breakDate: '',
    status: '',
    reason: '',
    document1: null,
    documentName1: '',
    document2: null,
    documentName2: '',
    document3: null,
    documentName3: '',
    document4: null,
    documentName4: '',
    document5: null,
    documentName5: '',
    document6: null,
    documentName6: '',
    document7: null,
    documentName7: '',
    document8: null,
    documentName8: '',
    document9: null,
    documentName9: '',
    document10: null,
    documentName10: '',
    referenceName: '',
    referenceNumber: '',
    servicedDate: '',
    serviceComments: '',
    labourCost: '',
    mCost: '',
    supervisedBy: '',
  };
  const spareFormFields = {
    spareName: '',
    quantity: '',
    description: '',
    document1: null,
    documentName1: '',
    document2: null,
    documentName2: '',
  };
  const spareRequestFormFields = {
    spareType: '',
    spareName: '',
    requestedBy: '',
    quantity: '',
    description: '',
    approvedBy: '',
    comment: '',
  };
  const resellScrapFormFields = {
    type: '',
    date: '',
    buyerName: '',
    buyerCNumber: '',
    buyerEmail: '',
    buyerCPerson: '',
    buyerGst: '',
    resellAmount: '',
    reason: '',
    approvedBy: '',
    supervisedBy: '',
    document1: null,
    documentName1: '',
    document2: null,
    documentName2: '',
    document3: null,
    documentName3: '',
  };
  const documentFields = { documentName: '', description: '', document1: null, documentName1: '', document2: null, documentName2: '' };
  const [purchaseOrderForm, setPurchaseOrderForm] = useState({
    purchaseNumber: '',
    vehicleName: '',
    amount: '',
    approvedDate: '',
    approvedBy: '',
    file1: null,
    file1Name: '',
    file2: null,
    file2Name: '',
    file3: null,
    file3Name: '',
  });
  const [serviceForm, setServiceForm] = useState(formFields);
  const [remainderForm, setRemainderForm] = useState(remainderFields);
  const [documentForm, setDocumentForm] = useState(documentFields);
  const [breakdownForm, setBreakdownForm] = useState(breakdownFormFields);
  const [spareForm, setSpareForm] = useState(spareFormFields);
  const [spareRequestForm, setSpareRequestForm] = useState(spareRequestFormFields);
  const [resellScrapForm, setResellScrapForm] = useState(resellScrapFormFields);
  const [serviceList, setServiceList] = useState([]);
  const [remainderList, setRemainderList] = useState([]);
  const [documentList, setDocumentList] = useState([]);
  const [breakdownList, setBreakdownList] = useState([]);
  const [spareList, setSpareList] = useState([]);
  const [spareRequestList, setSpareRequestList] = useState([]);
  const [serviceName, setServiceName] = useState('');
  const [searchVehicleName, setSearchVehicleName] = useState('');
  const [vehicleName, setVehicleName] = useState('');
  const [spareName, setSpareName] = useState('');
  const [spareRequestName, setSpareRequestName] = useState('');
  const [resellScrapInfo, setResellScrapInfo] = useState('');
  const [spareRequestIdToBeApproved, setSpareRequestIdToBeApproved] = useState('');
  const [showConfirmModel, setShowConfirmModel] = useState(false);
  const [showConfirmRemainderModel, setShowConfirmRemainderModel] = useState(false);
  const [showConfirmDocumentModel, setShowConfirmDocumentModel] = useState(false);
  const [breakdownShowConfirmModel, setBreakdownShowConfirmModel] = useState(false);
  const [spareShowConfirmModel, setSpareShowConfirmModel] = useState(false);
  const [spareShowRequestConfirmModel, setSpareShowRequestConfirmModel] = useState(false);
  const handleCloseConfirmModal = () => {
    setShowConfirmModel(false);
  };
  const handleCloseConfirmRemainderModal = () => {
    setShowConfirmRemainderModel(false);
  };
  const handleCloseConfirmDocumentModal = () => {
    setShowConfirmDocumentModel(false);
  };
  const handleCloseBreakdownConfirmModal = () => {
    setBreakdownShowConfirmModel(false);
  };
  const handleCloseSpareConfirmModal = () => {
    setSpareShowConfirmModel(false);
  };
  const handleCloseSpareRequestConfirmModal = () => {
    setSpareShowRequestConfirmModel(false);
  };
  const [idToDeleted, setIdToDeleted] = useState('');
  const [docToDeleted, setDocToDeleted] = useState('');
  const handleCloseServiceRemainderModal = () => {
    setShowServiceRemainderModal(false);
    setIsView(false);
    setServiceForm(formFields);
  };
  const handleCloseRemainderModal = () => {
    setShowRemainderModal(false);
  };
  const handleCloseDocumentModal = () => {
    setShowDocumentModal(false);
  };
  const handleCloseBreakdownModal = () => {
    setShowBreakdownModal(false);
  };
  const handleCloseSpareModal = () => {
    setShowSpareModal(false);
  };
  const handleCloseSpareRequestModal = () => {
    setShowSpareRequestModal(false);
  };
  const handleCloseResellScrapModal = () => {
    setShowResellScrapModal(false);
  };
  const handleCloseSpareRequestApproveModal = () => {
    setShowSpareRequestApproveModal(false);
  };
  const vehicleRequestFormFields = {
    model: '',
    vehicleType: '',
    requestedBy: '',
    initiatedBy: '',
    requestedDate: '',
    reason: '',
    file1: null,
    file1Name: '',
    file2: null,
    file2Name: '',
  };
  const transferValueFormFields = { factory: '', approvedBy: '', comment: '', supervisedBy: '' };
  const [vehicleForm, setVehicleForm] = useState(vehicleRequestFormFields);
  const [transferValue, setTransferValue] = useState(transferValueFormFields);
  const clickToDownload = useRef(null);
  const [show, setShow] = useState(false);
  const [showPurchaseModal, setShowPurchaseModal] = useState(false);
  const [showTransferModal, setShowTransferModal] = useState(false);
  const branches = useSelector((state) => state.common.vmBranches);
  const factories = branches.filter((item) => item?.type === 'factory');
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [isView, setIsView] = useState(false);

  const getFactoryData = () => {
    const factory = factories?.find((item) => item?.id === parseInt(runngingVehicleDetail?.factoryId));
    return factory?.name;
  };

  const factoryName = getFactoryData();
  if (factoryName) {
    runngingVehicleDetail.factoryName = factoryName;
  }

  const handleCloseModal = () => {
    setShowPurchaseModal(false);
  };
  const handleCloseTransferModal = () => {
    setShowTransferModal(false);
  };

  const handleShowModal = () => {
    setShowPurchaseModal(true);
    setValidated(false);
  };

  const handleShowTransferModal = () => {
    setShowTransferModal(true);
    setValidated(false);
  };

  const handleClose = () => setShow(false);

  const handleShow = () => {
    setShow(true);
    setVehicleForm(vehicleRequestFormFields);
  };

  const handleShowServiceRemainderModal = () => {
    setShowServiceRemainderModal(true);
    setValidated(false);
    setServiceForm(formFields);
  };

  const handleShowRemainderModal = () => {
    setShowRemainderModal(true);
    setValidated(false);
    setRemainderForm(remainderFields);
  };

  const handleShowBreakdownModal = () => {
    setShowBreakdownModal(true);
    setValidated(false);
    setBreakdownForm(breakdownFormFields);
  };

  const handleShowDocumentModal = () => {
    setShowDocumentModal(true);
    setValidated(false);
    setDocumentForm(documentFields);
  };

  const handleShowSpareModal = () => {
    setShowSpareModal(true);
    setValidated(false);
    setSpareForm(spareFormFields);
  };

  const handleShowSpareRequestModal = () => {
    setShowSpareRequestModal(true);
    setValidated(false);
    setSpareRequestForm(spareRequestFormFields);
  };

  const handleShowResellScrapModal = () => {
    setShowResellScrapModal(true);
    setValidated(false);
    setResellScrapForm(resellScrapFormFields);
  };

  const handleSpareRequestApproveModel = (e, id) => {
    setShowSpareRequestApproveModal(true);
    setSpareRequestIdToBeApproved(id);
    setSpareRequestForm(spareRequestFormFields);
  };

  const handleApproveChange = (e) => {
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;
    setSpareRequestForm({ ...spareRequestForm, [name]: value });
  };

  const handleVehicleChange = (event) => {
    event.preventDefault();
    let name = event.target.name;
    let value = event.target.value;
    setVehicleForm({ ...vehicleForm, [name]: value });
  };

  const handleTransferChange = (event) => {
    event.preventDefault();
    let name = event.target.name;
    let value = event.target.value;
    setTransferValue({ ...transferValue, [name]: value });
  };

  const handleFactory = (e) => {
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;
    setTransferValue({ ...transferValue, [name]: value });
  };

  const onChangeDocumentOne = (event) => {
    event.preventDefault();
    const file = event.target.files[0];
    if (file && file.name.match(/\.(exe|apk|bat|cmd|com|dll|jar|msi|py|sh)$/)) {
      event.target.value = ''; // Clear the selected file
      toast.error('Please select a valid file type.', { autoClose: 2000 });
    } else {
      setVehicleForm({ ...vehicleForm, file1: file || null, file1Name: file?.name || '' });
    }
  };

  const onChangeDocumentTwo = (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    if (file && file.name.match(/\.(exe|apk|bat|cmd|com|dll|jar|msi|py|sh)$/)) {
      e.target.value = ''; // Clear the selected file
      toast.error('Please select a valid file type.', { autoClose: 2000 });
    } else {
      setVehicleForm({ ...vehicleForm, file2: file || null, file2Name: file?.name || '' });
    }
  };

  const handleSpareReqApproveSubmit = async (e) => {
    e.preventDefault();
    try {
      const spareReqValue = await approveSpareRequest(spareRequestForm, params.id, spareRequestIdToBeApproved);
      toast.success('Spare Request Approved successfully');
      setShowSpareRequestApproveModal(false);
      getSparesRequest();
    } catch (err) {
      toast.error(err?.response?.data?.data?.message || err?.message);
    }
  };

  const handleChange = (e) => {
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;
    setServiceForm({ ...serviceForm, [name]: value });
  };

  const handleRemainderChange = (e) => {
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;
    setRemainderForm({ ...remainderForm, [name]: value });
  };

  const handleBreakdownChange = (e) => {
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;
    setBreakdownForm({ ...breakdownForm, [name]: value });
  };

  const handleSpareChange = (e) => {
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;
    setSpareForm({ ...spareForm, [name]: value });
  };

  const handleSpareRequestChange = (e) => {
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;
    setSpareRequestForm({ ...spareRequestForm, [name]: value });
  };

  const handleChangeScrap = (e) => {
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;
    setResellScrapForm({ ...resellScrapForm, [name]: value });
  };

  const handleDocumentChange = (e) => {
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;
    setDocumentForm({ ...documentForm, [name]: value });
  };

  const handleSelect = (e) => {
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;
    setServiceForm({ ...serviceForm, [name]: value });
  };

  const handleRemainderSelect = (e) => {
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;
    setRemainderForm({ ...remainderForm, [name]: value });
  };

  const handleTransferSubmit = async (e) => {
    if (runngingVehicleDetail.status !== 'SCRAP-RESELL') {
      e.preventDefault();
      let runningId = runngingVehicleDetail.id;
      let selectedFactoryId = transferValue.factory;
      try {
        await transferingVehicle(transferValue, selectedFactoryId, runningId);
        setShowTransferModal(false);
        navigate('/vm/running-vehicle');
        setTimeout(() => {
          toast.success('Vehicle Transfered successfully');
        }, 1000);
      } catch (err) {
        console.error(err);
        toast.error(err.message);
      }
    } else {
      toast.error('Scrapped or resold vehicles cannot be transferred.');
    }
  };

  const handleSelectSpare = (e) => {
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;
    const updatedForm = { ...spareRequestForm, [name]: value };
    if (name === 'spareType' && value === 'Tyre') {
      updatedForm.spareName = 'Tyre';
    } else if (name === 'spareType' && value === 'Other') {
      updatedForm.spareName = '';
    }
    setSpareRequestForm(updatedForm);
  };

  const handleBreakdownSelect = (e) => {
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;
    setBreakdownForm({ ...breakdownForm, [name]: value });
  };

  const handleResellScrapSelect = (e) => {
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;
    setResellScrapForm({ ...resellScrapForm, [name]: value });
  };

  const handleVehicleTypeSelect = (e) => {
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;
    setVehicleForm({ ...vehicleForm, [name]: value });
  };

  const onChangeDocument1 = (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    if (file && file.name.match(/\.(exe|apk|bat|cmd|com|dll|jar|msi|py|sh)$/)) {
      e.target.value = ''; // Clear the selected file
      toast.error('Please select a valid file type.', { autoClose: 2000 });
    } else {
      setServiceForm({ ...serviceForm, document1: file || null, documentName1: file?.name || '' });
    }
  };

  const onChangeDocDocument1 = (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    if (file && file.name.match(/\.(exe|apk|bat|cmd|com|dll|jar|msi|py|sh)$/)) {
      e.target.value = ''; // Clear the selected file
      toast.error('Please select a valid file type.', { autoClose: 2000 });
    } else {
      setDocumentForm({ ...documentForm, document1: file || null, documentName1: file?.name || '' });
    }
  };

  const onChangeDocDocument2 = (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    if (file && file.name.match(/\.(exe|apk|bat|cmd|com|dll|jar|msi|py|sh)$/)) {
      e.target.value = ''; // Clear the selected file
      toast.error('Please select a valid file type.', { autoClose: 2000 });
    } else {
      setDocumentForm({ ...documentForm, document2: file || null, documentName2: file?.name || '' });
    }
  };

  const onChangeRemainderDocument1 = (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    if (file && file.name.match(/\.(exe|apk|bat|cmd|com|dll|jar|msi|py|sh)$/)) {
      e.target.value = ''; // Clear the selected file
      toast.error('Please select a valid file type.', { autoClose: 2000 });
    } else {
      setRemainderForm({ ...remainderForm, document1: file || null, documentName1: file?.name || '' });
    }
  };

  const onChangeRemainderDocument2 = (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    if (file && file.name.match(/\.(exe|apk|bat|cmd|com|dll|jar|msi|py|sh)$/)) {
      e.target.value = ''; // Clear the selected file
      toast.error('Please select a valid file type.', { autoClose: 2000 });
    } else {
      setRemainderForm({ ...remainderForm, document2: file || null, documentName2: file?.name || '' });
    }
  };

  const onChangeDocument2 = (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    if (file && file.name.match(/\.(exe|apk|bat|cmd|com|dll|jar|msi|py|sh)$/)) {
      e.target.value = ''; // Clear the selected file
      toast.error('Please select a valid file type.', { autoClose: 2000 });
    } else {
      setServiceForm({ ...serviceForm, document2: file || null, documentName2: file?.name || '' });
    }
  };

  const onChangeDocument3 = (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    if (file && file.name.match(/\.(exe|apk|bat|cmd|com|dll|jar|msi|py|sh)$/)) {
      e.target.value = ''; // Clear the selected file
      toast.error('Please select a valid file type.', { autoClose: 2000 });
    } else {
      setServiceForm({ ...serviceForm, document3: file || null, documentName3: file?.name || '' });
    }
  };

  const onChangeDocument4 = (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    if (file && file.name.match(/\.(exe|apk|bat|cmd|com|dll|jar|msi|py|sh)$/)) {
      e.target.value = ''; // Clear the selected file
      toast.error('Please select a valid file type.', { autoClose: 2000 });
    } else {
      setServiceForm({ ...serviceForm, document4: file || null, documentName4: file?.name || '' });
    }
  };

  const onChangeBreakDocument = (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    if (file && file.name.match(/\.(exe|apk|bat|cmd|com|dll|jar|msi|py|sh)$/)) {
      e.target.value = ''; // Clear the selected file
      toast.error('Please select a valid file type.', { autoClose: 2000 });
    } else {
      const { name } = e.target;
      const fileName = e.target.dataset.filename;
      setBreakdownForm({ ...breakdownForm, [name]: file || null, [fileName]: file?.name || '' });
    }
  };

  const onChangeSpareDocument = (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    if (file && file.name.match(/\.(exe|apk|bat|cmd|com|dll|jar|msi|py|sh)$/)) {
      e.target.value = ''; // Clear the selected file
      toast.error('Please select a valid file type.', { autoClose: 2000 });
    } else {
      const { name } = e.target;
      const fileName = e.target.dataset.filename;
      setSpareForm({ ...spareForm, [name]: file || null, [fileName]: file?.name || '' });
    }
  };

  const onChangeResellScrapDocument = (e) => {
    e.preventDefault('onChangeResellScrapDocument');
    const file = e.target.files[0];
    if (file && file.name.match(/\.(exe|apk|bat|cmd|com|dll|jar|msi|py|sh)$/)) {
      e.target.value = ''; // Clear the selected file
      toast.error('Please select a valid file type.', { autoClose: 2000 });
    } else {
      const { name } = e.target;
      const fileName = e.target.dataset.filename;
      setResellScrapForm({ ...resellScrapForm, [name]: file || null, [fileName]: file?.name || '' });
    }
  };

  useEffect(() => {
    getRunningVehicle();
  }, []);

  const getRunningVehicle = async () => {
    const runningVehicleVal = await getSingleRunningVehicle(params?.id);
    setRunngingVehicleDetail(runningVehicleVal?.data);
  };

  /** Add/Edit Service */
  const handleSubmit = async (e) => {
    e.preventDefault();
    serviceForm.totalKm = totalKmsSubtract(serviceForm.currentKm, serviceForm.lastServiceKm);
    const formData = new FormData();
    for (var key in serviceForm) {
      if (
        key === 'document1' ||
        key === 'documentName1' ||
        key === 'document2' ||
        key === 'documentName2' ||
        key === 'document3' ||
        key === 'documentName3' ||
        key === 'document4' ||
        key === 'documentName4'
      )
        continue;
      formData.append(key, serviceForm[key]);
    }

    if (serviceForm.document1 !== null) formData.append('document1', serviceForm['document1'], serviceForm.documentName1);
    if (serviceForm.document2 !== null) formData.append('document2', serviceForm['document2'], serviceForm.documentName2);
    if (serviceForm.document3 !== null) formData.append('document3', serviceForm['document3'], serviceForm.documentName3);
    if (serviceForm.document4 !== null) formData.append('document4', serviceForm['document4'], serviceForm.documentName4);

    if (!serviceForm.runningVehicleId) formData.append('runningVehicleId', runngingVehicleDetail?.id);
    if (!serviceForm.runningVehicleName) formData.append('runningVehicleName', runngingVehicleDetail?.vehicleModelName);
    if (!serviceForm.runningVehicleNumber) formData.append('runningVehicleNumber', runngingVehicleDetail?.registrationNumber);

    if (serviceForm.id) {
      try {
        setIsButtonDisabled(false);
        await editServiceRemainder(formData, formData.get('id'));
        toast.success('Service Remainder updated successfully');
        setShowServiceRemainderModal(false);
        getService();
      } catch (err) {
        toast.error(err?.response?.data?.data?.message || 'Something went wrong', { autoClose: 3000 });
      }
    } else {
      if (isButtonDisabled) {
        return; // If button is disabled, return early
      }
      setIsButtonDisabled(true); // Disable the button
      try {
        await createServiceRemainder(formData);
        toast.success('Service Remainder Created successfully');
        setShowServiceRemainderModal(false);
        getService();
      } catch (err) {
        toast.error(err?.response?.data?.data?.message || 'Something went wrong', { autoClose: 3000 });
      } finally {
        // Enable the button after a delay of 3 seconds
        setTimeout(() => {
          setIsButtonDisabled(false);
        }, 500);
      }
    }
  };
  /** Add/Edit Remainders */
  const handleRemainderSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    for (var key in remainderForm) {
      if (key === 'document1' || key === 'documentName1' || key === 'document2' || key === 'documentName2') continue;
      formData.append(key, remainderForm[key]);
    }

    if (remainderForm.document1 !== null) formData.append('document1', remainderForm['document1'], remainderForm.documentName1);
    if (remainderForm.document2 !== null) formData.append('document2', remainderForm['document2'], remainderForm.documentName2);

    /** Adding running vehicle details to form */
    formData.append('runningVehicleId', runngingVehicleDetail?.id);
    formData.append('runningVehicleName', runngingVehicleDetail?.vehicleModelName);

    if ('id' in remainderForm) {
      try {
        setIsButtonDisabled(false);
        await editRemainder(remainderForm, remainderForm.id);
        toast.success('Remainder updated successfully');
        setShowRemainderModal(false);
        getRemainders();
      } catch (err) {
        toast.error(err?.response?.data?.data?.message || 'Something went wrong', { autoClose: 3000 });
      }
    } else {
      if (isButtonDisabled) {
        return; // If button is disabled, return early
      }
      setIsButtonDisabled(true); // Disable the button
      try {
        await createRemainder(formData);
        toast.success('Remainder Created successfully');
        setShowRemainderModal(false);
        getRemainders();
      } catch (err) {
        toast.error(err?.response?.data?.data?.message || 'Something went wrong', { autoClose: 3000 });
      } finally {
        // Enable the button after a delay of 3 seconds
        setTimeout(() => {
          setIsButtonDisabled(false);
        }, 500);
      }
    }
  };

  const handleVehicleSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData();
    for (var key in vehicleForm) {
      if (key === 'file1' || key === 'file1Name' || key === 'file2' || key === 'file2Name') continue;
      formData.append(key, vehicleForm[key]);
    }
    if (vehicleForm.file1 !== null) formData.append('file1', vehicleForm['file1'], vehicleForm.file1Name);
    if (vehicleForm.file2 !== null) formData.append('file2', vehicleForm['file2'], vehicleForm.file2Name);

    try {
      await createAfterVehicleRequest(formData, 'after', runngingVehicleDetail?.id);
      toast.success('Vehicle Request added successfully');
      setShow(false);
      getRunningVehicle();
    } catch (err) {
      toast.error(err.message, { autoClose: 2000 });
    }
  };

  const handleSubmitBreakdown = async (e) => {
    e.preventDefault();
    const formData = new FormData();

    for (var key in breakdownForm) {
      if (
        key === 'document1' ||
        key === 'documentName1' ||
        key === 'document2' ||
        key === 'documentName2' ||
        key === 'document3' ||
        key === 'documentName3' ||
        key === 'document4' ||
        key === 'documentName4' ||
        key === 'document5' ||
        key === 'documentName5' ||
        key === 'document6' ||
        key === 'documentName6' ||
        key === 'document7' ||
        key === 'documentName7' ||
        key === 'document8' ||
        key === 'documentName8' ||
        key === 'document9' ||
        key === 'documentName9' ||
        key === 'document10' ||
        key === 'documentName10'
      )
        continue;
      formData.append(key, breakdownForm[key]);
    }

    if (breakdownForm.document1 !== null) formData.append('document1', breakdownForm['document1'], breakdownForm.documentName1);
    if (breakdownForm.document2 !== null) formData.append('document2', breakdownForm['document2'], breakdownForm.documentName2);
    if (breakdownForm.document3 !== null) formData.append('document3', breakdownForm['document3'], breakdownForm.documentName3);
    if (breakdownForm.document4 !== null) formData.append('document4', breakdownForm['document4'], breakdownForm.documentName4);
    if (breakdownForm.document5 !== null) formData.append('document5', breakdownForm['document5'], breakdownForm.documentName5);
    if (breakdownForm.document6 !== null) formData.append('document6', breakdownForm['document6'], breakdownForm.documentName6);
    if (breakdownForm.document7 !== null) formData.append('document7', breakdownForm['document7'], breakdownForm.documentName7);
    if (breakdownForm.document8 !== null) formData.append('document8', breakdownForm['document8'], breakdownForm.documentName8);
    if (breakdownForm.document9 !== null) formData.append('document9', breakdownForm['document9'], breakdownForm.documentName9);
    if (breakdownForm.document10 !== null) formData.append('document10', breakdownForm['document10'], breakdownForm.documentName10);
    if (!breakdownForm.id) formData.append('runningVehicleId', runngingVehicleDetail?.id);
    formData.append('runningVehicleName', runngingVehicleDetail?.VehicleRequest?.model);

    if (breakdownForm.id) {
      try {
        setIsButtonDisabled(false);
        const breakdownValue = await editBreakdown(formData, breakdownForm.id);
        toast.success('Breakdown updated successfully');
        setShowBreakdownModal(false);
        getBreak();
      } catch (err) {
        console.error(err);
        toast.error(err.message);
      }
    } else {
      if (isButtonDisabled) {
        return; // If button is disabled, return early
      }
      setIsButtonDisabled(true); // Disable the button
      try {
        await createBreakdown(formData);
        toast.success('Breakdown Created successfully');
        setShowBreakdownModal(false);
        getBreak();
      } catch (err) {
        console.error(err);
        toast.error(err.message);
      } finally {
        // Enable the button after a delay of 3 seconds
        setTimeout(() => {
          setIsButtonDisabled(false);
        }, 500);
      }
    }
  };

  const handleSubmitSpare = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    for (var key in spareForm) {
      if (key === 'document1' || key === 'documentName1' || key === 'document2' || key === 'documentName2') continue;
      formData.append(key, spareForm[key]);
    }

    if (spareForm.document1 !== null) formData.append('document1', spareForm['document1'], spareForm.documentName1);
    if (spareForm.document2 !== null) formData.append('document2', spareForm['document2'], spareForm.documentName2);
    if (!spareForm.id) formData.append('runningVehicleId', runngingVehicleDetail?.id);
    if (spareForm.id) {
      try {
        setIsButtonDisabled(false);
        const spareValue = await editSpare(formData, spareForm.id);
        toast.success('Spare updated successfully');
        setShowSpareModal(false);
        getSpares();
      } catch (err) {
        console.error(err);
        toast.error(err.message);
      }
    } else {
      if (isButtonDisabled) {
        return; // If button is disabled, return early
      }
      setIsButtonDisabled(true); // Disable the button
      try {
        await createSpare(formData);
        toast.success('Spare Created successfully');
        setShowSpareModal(false);
        getSpares();
      } catch (err) {
        console.error(err);
        toast.error(err.message);
      } finally {
        // Enable the button after a delay of 3 seconds
        setTimeout(() => {
          setIsButtonDisabled(false);
        }, 500);
      }
    }
  };

  const handleSubmitSpareRequest = async (e) => {
    e.preventDefault();
    if (!spareRequestForm.id) spareRequestForm.runningVehicleId = runngingVehicleDetail?.id;

    if (spareRequestForm.id) {
      try {
        setIsButtonDisabled(false);
        const spareRequestValue = await editSpareRequestMethod(spareRequestForm, spareRequestForm.id, spareRequestForm.runningVehicleId);
        toast.success('Spare Request updated successfully');
        setShowSpareRequestModal(false);
        getSparesRequest();
      } catch (err) {
        console.error(err);
        toast.error(err.message);
      }
    } else {
      if (isButtonDisabled) {
        return; // If button is disabled, return early
      }
      setIsButtonDisabled(true); // Disable the button
      try {
        await createSpareRequest(spareRequestForm);
        toast.success('Spare Request Created successfully');
        setShowSpareRequestModal(false);
        getSparesRequest();
      } catch (err) {
        console.error(err);
        toast.error(err.message);
      } finally {
        // Enable the button after a delay of 3 seconds
        setTimeout(() => {
          setIsButtonDisabled(false);
        }, 500);
      }
    }
  };
  /** Resell Scrap */
  const handleSubmitResellScrap = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    for (var key in resellScrapForm) {
      if (
        key === 'document1' ||
        key === 'documentName1' ||
        key === 'document2' ||
        key === 'documentName2' ||
        key === 'document3' ||
        key === 'documentName3'
      )
        continue;
      formData.append(key, resellScrapForm[key]);
    }

    if (resellScrapForm.document1 !== null) formData.append('document1', resellScrapForm['document1'], resellScrapForm.documentName1);
    if (resellScrapForm.document2 !== null) formData.append('document2', resellScrapForm['document2'], resellScrapForm.documentName2);
    if (resellScrapForm.document3 !== null) formData.append('document3', resellScrapForm['document3'], resellScrapForm.documentName3);
    formData.append('runningVehicleId', runngingVehicleDetail?.id);
    try {
      await createResellScrap(formData);
      toast.success('Resell Scrap Created successfully');
      setShowResellScrapModal(false);
      getResellScraping();
    } catch (err) {
      toast.error(err?.response?.data?.data?.message || 'Something went wrong', { autoClose: 3000 });
    }
  };
  /** Add/Edit Document */
  const handleDocumentSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    for (var key in documentForm) {
      if (key === 'document1' || key === 'documentName1' || key === 'document2' || key === 'documentName2') continue;
      formData.append(key, documentForm[key]);
    }

    if (documentForm.document1 !== null) formData.append('document1', documentForm['document1'], documentForm.documentName1);
    if (documentForm.document2 !== null) formData.append('document2', documentForm['document2'], documentForm.documentName2);

    if (!documentForm.runningVehicleId) formData.append('runningVehicleId', runngingVehicleDetail?.id);
    if (!documentForm.runningVehicleName) formData.append('runningVehicleName', runngingVehicleDetail?.vehicleModelName);

    if (documentForm.id) {
      try {
        setIsButtonDisabled(false);
        const documentValue = await editDocument(formData, formData.get('id'));
        toast.success('Document updated successfully');
        setShowDocumentModal(false);
        getDocuments();
      } catch (err) {
        console.error(err);
        toast.error(err.message);
      }
    } else {
      if (isButtonDisabled) {
        return; // If button is disabled, return early
      }
      setIsButtonDisabled(true); // Disable the button
      try {
        await createDocument(formData);
        toast.success('Document Created successfully');
        setShowDocumentModal(false);
        getDocuments();
      } catch (err) {
        console.error(err);
        toast.error(err.message);
      } finally {
        // Enable the button after a delay of 3 seconds
        setTimeout(() => {
          setIsButtonDisabled(false);
        }, 500);
      }
    }
  };

  const getServiceRemainderList = async (limit = TABLE_DEFAULT_LIMIT, offset = 0, id = 0) => {
    try {
      let condition = {
        name: serviceName || '',
      };
      const serviceRemainderList = await getServiceRemainder(offset, condition, limit, params.id, id);

      return id === 0
        ? {
          data: (serviceRemainderList && serviceRemainderList.data.rows) || [],
          totalRecords: (serviceRemainderList && serviceRemainderList.data && serviceRemainderList.data.count) || 0,
        }
        : {
          data: (serviceRemainderList && serviceRemainderList.data) || [],
        };
    } catch (e) {
      console.error(e);
      return {
        errorMessage: e.message,
      };
    }
  };

  const getRemainderList = async (limit = TABLE_DEFAULT_LIMIT, offset = 0, id = 0) => {
    try {
      let condition = {
        name: searchVehicleName || '',
      };
      const RemainderList = await getRemainder(offset, condition, limit, params.id, id);
      return id === 0
        ? {
          data: (RemainderList && RemainderList.data.rows) || [],
          totalRecords: (RemainderList && RemainderList.data && RemainderList.data.count) || 0,
        }
        : {
          data: (RemainderList && RemainderList.data) || [],
        };
    } catch (e) {
      console.error(e);
      return {
        errorMessage: e.message,
      };
    }
  };

  const getDocumentList = async (limit = TABLE_DEFAULT_LIMIT, offset = 0, id = 0) => {
    try {
      let condition = {
        name: searchVehicleName || '',
      };
      const DocumentList = await getDocument(offset, condition, limit, params.id, id);
      return id === 0
        ? {
          data: (DocumentList && DocumentList.data.rows) || [],
          totalRecords: (DocumentList && DocumentList.data && DocumentList.data.count) || 0,
        }
        : {
          data: (DocumentList && DocumentList.data) || [],
        };
    } catch (e) {
      console.error(e);
      return {
        errorMessage: e.message,
      };
    }
  };

  const getBreakdownList = async (limit = TABLE_DEFAULT_LIMIT, offset = 0, id = 0) => {
    try {
      let condition = {
        name: vehicleName || '',
      };
      const breakdownList = await getBreakdown(offset, condition, limit, params.id, id);

      return id === 0
        ? {
          data: (breakdownList && breakdownList.data.rows) || [],
          totalRecords: (breakdownList && breakdownList.data && breakdownList.data.count) || 0,
        }
        : {
          data: (breakdownList && breakdownList.data) || [],
        };
    } catch (e) {
      console.error(e);
      return {
        errorMessage: e.message,
      };
    }
  };

  const getSpareList = async (limit = TABLE_DEFAULT_LIMIT, offset = 0, id = 0) => {
    try {
      let condition = {
        name: spareName || '',
      };
      const spareList = await getSpare(offset, condition, limit, params.id, id);
      return id === 0
        ? {
          data: (spareList && spareList.data.rows) || [],
          totalRecords: (spareList && spareList.data && spareList.data.count) || 0,
        }
        : {
          data: (spareList && spareList.data) || [],
        };
    } catch (e) {
      console.error(e);
      return {
        errorMessage: e.message,
      };
    }
  };

  const getSpareRequestList = async (limit = TABLE_DEFAULT_LIMIT, offset = 0, id = 0) => {
    try {
      let condition = {
        name: spareRequestName || '',
      };
      const spareRequestList = await getSpareRequest(offset, condition, limit, params.id, id);
      return id === 0
        ? {
          data: (spareRequestList && spareRequestList.data.rows) || [],
          totalRecords: (spareRequestList && spareRequestList.data && spareRequestList.data.count) || 0,
        }
        : {
          data: (spareRequestList && spareRequestList.data) || [],
        };
    } catch (e) {
      console.error(e);
      return {
        errorMessage: e.message,
      };
    }
  };

  useEffect(() => {
    getService();
    getRemainders();
    getDocuments();
    getBreak();
    getSpares();
    getSparesRequest();
    getResellScraping();
  }, []);

  const getService = async () => {
    const listServiceRemainder = await getServiceRemainderList(TABLE_DEFAULT_LIMIT, currentPage);
    setTotalRecords(listServiceRemainder.totalRecords);
    setServiceList(listServiceRemainder.data);
  };

  const getRemainders = async () => {
    const listRemainder = await getRemainderList(TABLE_DEFAULT_LIMIT, currentPage);
    setTotalRecords(listRemainder.totalRecords);
    setRemainderList(listRemainder.data);
  };

  const getDocuments = async () => {
    const listDocument = await getDocumentList(TABLE_DEFAULT_LIMIT, currentPage);
    setTotalRecords(listDocument.totalRecords);
    setDocumentList(listDocument.data);
  };

  const getBreak = async () => {
    const listBreakdown = await getBreakdownList(TABLE_DEFAULT_LIMIT, currentPage);
    setTotalRecords(listBreakdown.totalRecords);
    setBreakdownList(listBreakdown.data);
  };

  const getSpares = async () => {
    const listSpare = await getSpareList(TABLE_DEFAULT_LIMIT, currentPage);
    setTotalRecords(listSpare.totalRecords);
    setSpareList(listSpare.data);
  };

  const getSparesRequest = async () => {
    const listSpareRequest = await getSpareRequestList(TABLE_DEFAULT_LIMIT, currentPage);
    setTotalRecords(listSpareRequest.totalRecords);
    setSpareRequestList(listSpareRequest.data);
  };

  const editServiceRemainderRequest = async (e, id, type) => {
    e.preventDefault();
    const getServiceRemainder = async () => {
      const data = await getSingleServiceRemainder(id);
      const hole = data?.data;
      hole.dueDate = moment(hole.dueDate).format('YYYY-MM-DD');
      if (hole.servicedDate !== null) hole.servicedDate = moment(hole.servicedDate).format('YYYY-MM-DD');
      if (type === 'view') {
        setServiceForm(hole);
        setIsView(true);
      }
      else {
        hole.document1 = null;
        hole.document2 = null;
        hole.document3 = null;
        hole.document4 = null;
        setServiceForm(hole);
      }
      setShowServiceRemainderModal(true);
    };
    getServiceRemainder();
  };

  const editRemainderRequest = async (e, id) => {
    e.preventDefault();
    const getRemainder = async () => {
      const data = await getSingleRemainder(id);
      const hole = data?.data;
      hole.dueDate = moment(hole.dueDate).format('YYYY-MM-DD');
      if (hole.completedDate !== null) hole.completedDate = moment(hole.completedDate).format('YYYY-MM-DD');
      hole.document1 = null;
      hole.document2 = null;
      setRemainderForm(hole);
      setShowRemainderModal(true);
    };
    getRemainder();
  };

  const editDocumentRequest = async (e, id) => {
    e.preventDefault();
    const getDocument = async () => {
      const data = await getSingleDocument(id);
      const hole = data?.data;
      hole.document1 = null;
      hole.document2 = null;
      setDocumentForm(hole);
      setShowDocumentModal(true);
    };
    getDocument();
  };

  const editBreakdownRequest = async (e, id) => {
    e.preventDefault();
    const getBreaksDown = async () => {
      const data = await getSingleBreakdown(id);
      data.data.breakDate = moment(data.data.breakDate).format('YYYY-MM-DD');
      if (data.data.servicedDate !== null) data.data.servicedDate = moment(data.data.servicedDate).format('YYYY-MM-DD');
      const breakDownData = data.data;
      for (let index = 1; index < 11; index++) {
        breakDownData['document' + index] = null;
      }
      setBreakdownForm(breakDownData);
      setShowBreakdownModal(true);
    };
    getBreaksDown();
  };

  const editSpareRequest = async (e, id) => {
    e.preventDefault();
    const getSpareValue = async () => {
      const data = await getSingleSpare(id);
      const spareData = data.data;
      for (let index = 1; index < 11; index++) {
        spareData['document' + index] = null;
      }
      setSpareForm(spareData);
      setShowSpareModal(true);
    };
    getSpareValue();
  };

  const editSpareRequestE = async (e, id) => {
    e.preventDefault();
    const getSpareRequestValue = async () => {
      const data = await getSingleSpareRequest(params.id, id);
      setSpareRequestForm(data.data);
      setShowSpareRequestModal(true);
    };
    getSpareRequestValue();
  };

  const getResellScraping = async () => {
    const data = await getSingleResellScrap(params.id);
    setResellScrapInfo(data.data);
  };

  const handleShowConfirmModal = (e, id) => {
    e.preventDefault();
    setShowConfirmModel(true);
    setIdToDeleted(id);
  };

  const handleShowRemainderConfirmModal = (e, id) => {
    e.preventDefault();
    setShowConfirmRemainderModel(true);
    setIdToDeleted(id);
  };

  const handleShowDocumentConfirmModal = (e, id, purchaseOrderId) => {
    e.preventDefault();
    setShowConfirmDocumentModel(true);
    setIdToDeleted(id);
    setDocToDeleted(purchaseOrderId);
  };

  const handleBreakdownConfirmModal = (e, id) => {
    e.preventDefault();
    setBreakdownShowConfirmModel(true);
    setIdToDeleted(id);
  };

  const handleSpareConfirmModal = (e, id) => {
    e.preventDefault();
    setSpareShowConfirmModel(true);
    setIdToDeleted(id);
  };

  const handleSpareRequestConfirmModal = (e, id) => {
    e.preventDefault();
    setSpareShowRequestConfirmModel(true);
    setIdToDeleted(id);
  };

  const handleRemove = (event, id) => {
    event.preventDefault();
    const deleteService = async () => {
      const data = await deleteServiceRemainder(id);
      toast.success(data.data);
      getService();
      setShowConfirmModel(false);
    };
    deleteService();
  };

  const handleRemainderRemove = (event, id) => {
    event.preventDefault();
    const deleteRemainders = async () => {
      const data = await deleteRemainder(id);
      toast.success(data.data);
      getRemainders();
      setShowConfirmRemainderModel(false);
    };
    deleteRemainders();
  };

  const handleDocumentRemove = (event, id, purchaseOrderId) => {
    event.preventDefault();
    const deleteDocuments = async () => {
      const data = await deleteDocument(id, purchaseOrderId);
      getDocuments();
      getRunningVehicle();
      toast.success(data.data);
      setShowConfirmDocumentModel(false);
    };
    deleteDocuments();
  };

  const handleRemoveBreakdown = (event, id) => {
    event.preventDefault();
    const deleteBreak = async () => {
      const data = await deleteBreakdown(id);
      toast.success(data.data);
      getBreak();
      setBreakdownShowConfirmModel(false);
    };
    deleteBreak();
  };

  const handleRemoveSpare = (event, id) => {
    event.preventDefault();
    const deleteSpares = async () => {
      const data = await deleteSpare(id);
      toast.success(data.data);
      getSpares();
      setSpareShowConfirmModel(false);
    };
    deleteSpares();
  };

  const handleRemoveSpareRequest = (event, id) => {
    event.preventDefault();
    const deleteSparesRequest = async () => {
      const data = await deleteSpareRequest(id);
      toast.success(data.data);
      getSparesRequest();
      setSpareShowRequestConfirmModel(false);
    };
    deleteSparesRequest();
  };

  const handleDownload = async (e, isRunningVehicle) => {
    e.preventDefault();
    try {
      const data = await getFullRunningVehicleReport(runngingVehicleDetail.VehicleRequestId, isRunningVehicle);
      if (data.data) {
        clickToDownload.current.href = `${process.env.REACT_APP_BASE_URL}/file/download?filePath=` + data.data;
        setTimeout(() => {
          clickToDownload.current.click();
        }, 500);
      }
    } catch (err) {
      console.error(err);
      toast.error(err.message);
    }
  };

  const handleDownloadOne = async (e, isRunningVehicle) => {
    e.preventDefault();
    try {
      const data = await getFullRunningVehicleReportOne(runngingVehicleDetail.id, isRunningVehicle);
      if (data.data) {
        clickToDownload.current.href = `${process.env.REACT_APP_BASE_URL}/file/download?filePath=` + data.data;
        setTimeout(() => {
          clickToDownload.current.click();
        }, 500);
      }
    } catch (err) {
      console.error(err);
      toast.error(err.message);
    }
  };

  const handleDownloadTwo = async (e, isRunningVehicle) => {
    e.preventDefault();
    try {
      const data = await getFullRunningVehicleReportTwo(runngingVehicleDetail.VehicleRequestId, isRunningVehicle);
      if (data.data) {
        clickToDownload.current.href = `${process.env.REACT_APP_BASE_URL}/file/download?filePath=` + data.data;
        setTimeout(() => {
          clickToDownload.current.click();
        }, 500);
      }
    } catch (err) {
      console.error(err);
      toast.error(err.message);
    }
  };

  const handleChangePurchaseOrder = (e) => {
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;
    setPurchaseOrderForm({ ...purchaseOrderForm, [name]: value });
  };

  const onChangePurchaseDocumentOne = (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    if (file && file.name.match(/\.(exe|apk|bat|cmd|com|dll|jar|msi|py|sh)$/)) {
      e.target.value = ''; // Clear the selected file
      toast.error('Please select a valid file type.', { autoClose: 2000 });
    } else {
      setPurchaseOrderForm({ ...purchaseOrderForm, file1: file || null, file1Name: file?.name || '' });
    }
  };
  const onChangePurchaseDocumentTwo = (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    if (file && file.name.match(/\.(exe|apk|bat|cmd|com|dll|jar|msi|py|sh)$/)) {
      e.target.value = ''; // Clear the selected file
      toast.error('Please select a valid file type.', { autoClose: 2000 });
    } else {
      setPurchaseOrderForm({ ...purchaseOrderForm, file2: file || null, file2Name: file?.name || '' });
    }
  };
  const onChangePurchaseDocumentThree = (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    if (file && file.name.match(/\.(exe|apk|bat|cmd|com|dll|jar|msi|py|sh)$/)) {
      e.target.value = ''; // Clear the selected file
      toast.error('Please select a valid file type.', { autoClose: 2000 });
    } else {
      setPurchaseOrderForm({ ...purchaseOrderForm, file3: file || null, file3Name: file?.name || '' });
    }
  };

  const handleApprove = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    for (var key in purchaseOrderForm) {
      if (key === 'file1' || key === 'file1Name' || key === 'file2' || key === 'file2Name' || key === 'file3' || key === 'file3Name')
        continue;
      formData.append(key, purchaseOrderForm[key]);
    }
    if (purchaseOrderForm.file1 !== null) formData.append('file1', purchaseOrderForm['file1'], purchaseOrderForm.file1Name);
    if (purchaseOrderForm.file2 !== null) formData.append('file2', purchaseOrderForm['file2'], purchaseOrderForm.file2Name);
    if (purchaseOrderForm.file3 !== null) formData.append('file3', purchaseOrderForm['file3'], purchaseOrderForm.file3Name);

    try {
      await createAfterPurchaseOrder(formData, 'after', runngingVehicleDetail?.id, runngingVehicleDetail.VehicleRequestId);
      setShowPurchaseModal(false);
      getRunningVehicle();
      getRunningVehicle();
    } catch (err) {
      console.error(err);
      toast.error(err.message);
    }
  };

  const handleServiceDownload = async (e, id) => {
    e.preventDefault();
    try {
      const data = await getSingleServiceInfo(id, runngingVehicleDetail.id, runngingVehicleDetail?.VehicleRequest?.vehicleType);
      if (data.data) {
        clickToDownload.current.href = `${process.env.REACT_APP_BASE_URL}/file/download?filePath=` + data.data;
        setTimeout(() => {
          clickToDownload.current.click();
        }, 500);
      }
    } catch (err) {
      console.error(err);
      toast.error(err.message);
    }
  };
  const [activeTabKey, setActiveTabKey] = useState(null);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  useEffect(() => {
    const tabFromQueryParam = searchParams.get('activeTab');
    setActiveTabKey(tabFromQueryParam || 'request');
  }, []);

  return (
    <React.Fragment>
      <ToastContainer />
      <nav className="" aria-label="breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <Link to="/vm/running-vehicle">Running Vehicle List</Link>
          </li>
          <li className="breadcrumb-item">
            <Link to="">Running Vehicle Detail</Link>
          </li>
        </ol>
      </nav>
      <div className="card">
        <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
          <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
            Running Vehicle Detail
          </h4>
          <a ref={clickToDownload} href="" target="_blank" className="hiddenItem">
            HiddenClick
          </a>
          {runngingVehicleDetail.VehicleRequestId && runngingVehicleDetail.PurchaseOrderId ? (
            <button type="button" onClick={(e) => handleDownload(e, 'isRunningVehicle')} className="btn app-btn-default dark-color">
              Download Report
            </button>
          ) : (
            ''
          )}
          {!runngingVehicleDetail.VehicleRequestId && !runngingVehicleDetail.PurchaseOrderId ? (
            <button type="button" onClick={(e) => handleDownloadOne(e, 'isRunningVehicle')} className="btn app-btn-default dark-color">
              Download Report
            </button>
          ) : (
            ''
          )}
          {runngingVehicleDetail.VehicleRequestId && !runngingVehicleDetail.PurchaseOrderId ? (
            <button type="button" onClick={(e) => handleDownloadTwo(e, 'isRunningVehicle')} className="btn app-btn-default dark-color">
              Download Report
            </button>
          ) : (
            ''
          )}
        </div>
        <div className="card-body">
          <Row className="top-row">
            <div className="col-md-2">
              <dd className="display-title mb-1">Registration Number</dd>
              <dt className="display-value">{runngingVehicleDetail.registrationNumber}</dt>
            </div>
            <div className="col-md-2">
              <dd className="display-title mb-1">Vehicle Name</dd>
              <dt className="display-value">
                {!runngingVehicleDetail.vehicleRequestId ? runngingVehicleDetail.vehicleModelName : runngingVehicleDetail?.VehicleRequest?.model}
              </dt>
            </div>
            <div className="col-md-2">
              <dd className="display-title mb-1">Additional Charges</dd>
              <dt className="display-value">{runngingVehicleDetail.charges}</dt>
            </div>
            <div className="col-md-2">
              <dd className="display-title mb-1">Status</dd>
              <dt className="display-value">{runngingVehicleDetail.status}</dt>
            </div>
            <div className="col-md-2">
              <dd className="display-title mb-1">Description</dd>
              <dt className="display-value">{runngingVehicleDetail.description}</dt>
            </div>
            <div className="col-md-2">
              <dd className="display-title mb-1">On Road Date</dd>
              <dt className="display-value">{formatDate(runngingVehicleDetail.onRoadDate)}</dt>
            </div>
            <div className="col-md-2">
              <dd className="display-title mb-1">Reference Name</dd>
              <dt className="display-value">{runngingVehicleDetail.referenceName}</dt>
            </div>
            <div className="col-md-2">
              <dd className="display-title mb-1">Reference Contact</dd>
              <dt className="display-value">{runngingVehicleDetail.referenceMobile}</dt>
            </div>
            <div className="col-md-2">
              <dd className="display-title mb-1">Location</dd>
              <dt className="display-value">{runngingVehicleDetail.location}</dt>
            </div>
            <div className="col-md-2">
              <dd className="display-title mb-1">Factory</dd>
              <dt className="display-value">{runngingVehicleDetail?.factoryName}</dt>
            </div>
            <div className="col-md-2">
              <button
                disabled={runngingVehicleDetail?.status === 'SCRAP-RESELL'}
                onClick={handleShowTransferModal}
                type="button"
                className="btn app-btn-default dark-color"
              >
                Transfer
              </button>
            </div>
          </Row>
        </div>
      </div>
      <div>
        {activeTabKey && (
          <Tabs defaultActiveKey={activeTabKey} id="uncontrolled-tab-example" className="mb-3">
            <Tab eventKey="request" title="Requests">
              {runngingVehicleDetail.VehicleRequestId ? (
                <div className="card">
                  <div className="card-body">
                    <Row className="top-row">
                      <div className="col-md-2">
                        <dd className="display-title mb-1">Vehicle Name</dd>
                        <dt className="display-value">{runngingVehicleDetail?.VehicleRequest?.model}</dt>
                      </div>
                      <div className="col-md-2">
                        <dd className="display-title mb-1">Requested Date</dd>
                        <dt className="display-value">{formatDate(runngingVehicleDetail?.VehicleRequest?.requestedDate)}</dt>
                      </div>
                      <div className="col-md-2">
                        <dd className="display-title mb-1">Status</dd>
                        <dt className="display-value">{runngingVehicleDetail?.VehicleRequest?.status}</dt>
                      </div>
                      <div className="col-md-2">
                        <dd className="display-title mb-1">Requested By</dd>
                        <dt className="display-value">{runngingVehicleDetail?.VehicleRequest?.requestedBy}</dt>
                      </div>
                      <div className="col-md-2">
                        <dd className="display-title mb-1">Initiated By</dd>
                        <dt className="display-value">{runngingVehicleDetail?.VehicleRequest?.initiatedBy}</dt>
                      </div>
                      <div className="col-md-2">
                        <dd className="display-title mb-1">Reason</dd>
                        <dt className="display-value">{runngingVehicleDetail?.VehicleRequest?.reason}</dt>
                      </div>
                    </Row>
                  </div>
                </div>
              ) : (
                <button type="button" className="btn app-btn-default dark-color" onClick={handleShow}>
                  Create Request
                </button>
              )}
              <div className="card top-card mt-4">
                <div className="card-body">
                  <div className="row">
                    <div className="form-group col-md-4 col-lg-4">
                      <label htmlFor="exampleInputEmail1">Spare Name</label>
                      <input
                        type="text"
                        className="form-control"
                        id="exampleInputEmail1"
                        placeholder="Please enter Spare Name"
                        value={spareRequestName}
                        onChange={(e) => {
                          setSpareRequestName(e.target.value);
                        }}
                      />
                    </div>
                    <div className="form-group col-md-8 col-lg-8">
                      <div className="btn-wrapper justify-content-start cmt-3">
                        <button type="button" className="btn app-btn-primary" onClick={getSparesRequest}>
                          Search
                        </button>
                        <button type="button" className="btn app-btn-default" onClick={() => setSpareRequestName('')}>
                          Reset
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card">
                <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
                  <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
                    Spare Request | {spareRequestList.length}
                  </h4>
                  {/* <button onClick={handleShowSpareRequestModal} type="button" className="btn app-btn-primary">Create</button> */}
                </div>
                <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
                  <div className="row">
                    <div className="col">
                      <Table responsive striped>
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Spare Name</th>
                            <th>Status</th>
                            <th>Quantity</th>
                            <th>Requested By</th>
                            <th>Description</th>
                            {/* <th>Action</th> */}
                          </tr>
                        </thead>
                        <tbody>
                          {spareRequestList?.map((request, index) => {
                            return (
                              <tr key={request.id}>
                                <td>{(currentPage - 1) * TABLE_DEFAULT_LIMIT + (index + 1)}</td>
                                <td>{request.spareName}</td>
                                <td>{request.status}</td>
                                <td>{request.quantity}</td>
                                <td>{request.requestedBy}</td>
                                <td>{request.description}</td>
                                {/* <td className="actions" style={{ paddingRight: "0px" }}>
                                <span onClick={(e) => editSpareRequestE(e, request.id)} className="edit-icon"><EditIcon /></span>&nbsp;&nbsp;
                                <Link to="/" onClick={(e) => handleSpareRequestConfirmModal(e, request.id)}><DeleteIcon /></Link>
                              </td> */}
                              </tr>
                            );
                          })}
                        </tbody>
                      </Table>
                      <PaginationInPage
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        totalRecords={totalRecords}
                        TABLE_DEFAULT_LIMIT={TABLE_DEFAULT_LIMIT}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Tab>
            <Tab eventKey="po" title="Purchase Order">
              {runngingVehicleDetail?.VehicleRequestId && !runngingVehicleDetail?.PurchaseOrder ? (
                <button type="button" className="btn app-btn-default dark-color" onClick={handleShowModal}>
                  Add PO
                </button>
              ) : (
                ''
              )}
              {runngingVehicleDetail?.PurchaseOrder ? (
                <div className="card">
                  <div className="card-body">
                    <Row className="top-row">
                      <div className="col-md-2">
                        <dd className="display-title mb-1">PO Number</dd>
                        <dt className="display-value">{runngingVehicleDetail?.PurchaseOrder?.purchaseNumber}</dt>
                      </div>
                      <div className="col-md-3">
                        <dd className="display-title mb-1">Vehicle Name</dd>
                        <dt className="display-value">{runngingVehicleDetail?.PurchaseOrder?.vehicleName}</dt>
                      </div>
                      <div className="col-md-2">
                        <dd className="display-title mb-1">Amount</dd>
                        <dt className="display-value">{runngingVehicleDetail?.PurchaseOrder?.amount}</dt>
                      </div>
                      <div className="col-md-2">
                        <dd className="display-title mb-1">Approved By</dd>
                        <dt className="display-value">{runngingVehicleDetail?.PurchaseOrder?.approvedBy}</dt>
                      </div>
                      <div className="col-md-2">
                        <dd className="display-title mb-1">Approved Date</dd>
                        <dt className="display-value">{formatDate(runngingVehicleDetail?.PurchaseOrder?.approvedDate)}</dt>
                      </div>
                    </Row>
                    <Row>
                      <Col xs={4}>
                        <h6>Downloads</h6>
                        <ul className="list-group">
                          {runngingVehicleDetail?.PurchaseOrder?.file1 !== null ? (
                            <li className="list-group-item">
                              <Row>
                                <Col xs={8} className="file-name">
                                  {runngingVehicleDetail?.PurchaseOrder?.file1Name}
                                </Col>
                                <Col xs={4} className="text-end actions">
                                  <a
                                    href={`${process.env.REACT_APP_BASE_URL}/file/download?filePath=${runngingVehicleDetail?.PurchaseOrder?.file1}`}
                                  >
                                    <DownloadIcon />
                                  </a>
                                  <DeleteIcon
                                    onClick={(e) => handleShowDocumentConfirmModal(e, 'file1', runngingVehicleDetail?.purchaseOrderId)}
                                    style={{ color: 'rgb(220, 53, 69)', cursor: 'pointer' }}
                                  />
                                </Col>
                              </Row>
                            </li>
                          ) : (
                            ''
                          )}
                          {runngingVehicleDetail?.PurchaseOrder?.file2 !== null ? (
                            <li className="list-group-item">
                              <Row>
                                <Col xs={8} className="file-name">
                                  {runngingVehicleDetail?.PurchaseOrder?.file2Name}
                                </Col>
                                <Col xs={4} className="text-end actions">
                                  <a
                                    href={`${process.env.REACT_APP_BASE_URL}/file/download?filePath=${runngingVehicleDetail?.PurchaseOrder?.file2}`}
                                  >
                                    <DownloadIcon />
                                  </a>
                                  <DeleteIcon
                                    onClick={(e) => handleShowDocumentConfirmModal(e, 'file2', runngingVehicleDetail?.purchaseOrderId)}
                                    style={{ color: 'rgb(220, 53, 69)', cursor: 'pointer' }}
                                  />
                                </Col>
                              </Row>
                            </li>
                          ) : (
                            ''
                          )}
                          {runngingVehicleDetail?.PurchaseOrder?.file3 !== null ? (
                            <li className="list-group-item">
                              <Row>
                                <Col xs={8} className="file-name">
                                  {runngingVehicleDetail?.PurchaseOrder?.file3Name}
                                </Col>
                                <Col xs={4} className="text-end actions">
                                  <a
                                    href={`${process.env.REACT_APP_BASE_URL}/file/download?filePath=${runngingVehicleDetail?.PurchaseOrder?.file3}`}
                                  >
                                    <DownloadIcon />
                                  </a>
                                  <DeleteIcon
                                    onClick={(e) => handleShowDocumentConfirmModal(e, 'file3', runngingVehicleDetail?.purchaseOrderId)}
                                    style={{ color: 'rgb(220, 53, 69)', cursor: 'pointer' }}
                                  />
                                </Col>
                              </Row>
                            </li>
                          ) : (
                            ''
                          )}
                        </ul>
                      </Col>
                    </Row>
                  </div>
                </div>
              ) : (
                ''
              )}
              {!runngingVehicleDetail?.PurchaseOrder && !runngingVehicleDetail?.VehicleRequestId ? (
                <div className="card">
                  <div className="card-body p-0">
                    <div className="alert alert-warning mb-0" role="alert">
                      <strong>First Need to Create Vehicle Request</strong>
                    </div>
                  </div>
                </div>
              ) : (
                ''
              )}
            </Tab>
            <Tab eventKey="service-remainder" title="Services">
              <div className="card top-card">
                <div className="card-body">
                  <div className="row">
                    <div className="form-group col-md-4 col-lg-4">
                      <label htmlFor="exampleInputEmail1">Service Name</label>
                      <input
                        type="text"
                        className="form-control"
                        id="exampleInputEmail1"
                        placeholder="Please enter Service Name"
                        value={serviceName}
                        onChange={(e) => {
                          setServiceName(e.target.value);
                        }}
                      />
                    </div>
                    <div className="form-group col-md-8 col-lg-8">
                      <div className="btn-wrapper justify-content-start cmt-3">
                        <button type="button" className="btn app-btn-primary" onClick={getService}>
                          Search
                        </button>
                        <button
                          type="button"
                          className="btn app-btn-default"
                          onClick={(e) => {
                            setServiceName('');
                          }}
                        >
                          Reset
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card">
                <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
                  <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
                    Services | {serviceList?.length}
                  </h4>
                  <button onClick={handleShowServiceRemainderModal} type="button" className="btn app-btn-primary">
                    Create
                  </button>
                </div>
                <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
                  <div className="row">
                    <div className="col">
                      <Table responsive striped>
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Name</th>
                            <th>Purpose</th>
                            <th>Type</th>
                            <th>Status</th>
                            <th>Due Date</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {serviceList?.map((request, index) => {
                            return (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{request.serviceName}</td>
                                <td>{request.description}</td>
                                <td>{request.serviceType}</td>
                                <td>{request.serviceStatus}</td>
                                <td>{formatDate(request.dueDate)}</td>
                                <td className="actions">
                                  <Link to="" onClick={(e) => handleServiceDownload(e, request.id)}>
                                    <DownloadIcon />
                                  </Link>
                                  <span onClick={(e) => editServiceRemainderRequest(e, request.id, "edit")} className="edit-icon">
                                    <EditIcon />
                                  </span>
                                  &nbsp;&nbsp;
                                  &nbsp;&nbsp;
                                  <span onClick={(e) => editServiceRemainderRequest(e, request.id, "view")} className="view-icon">
                                    <ViewIcon />
                                  </span>
                                  <Link to="/" onClick={(e) => handleShowConfirmModal(e, request.id)}>
                                    <DeleteIcon />
                                  </Link>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </Table>
                      <PaginationInPage
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        totalRecords={totalRecords}
                        TABLE_DEFAULT_LIMIT={TABLE_DEFAULT_LIMIT}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Tab>
            <Tab eventKey="remainder" title="Remainder">
              <div className="card top-card">
                <div className="card-body">
                  <div className="row">
                    <div className="form-group col-md-4 col-lg-4">
                      <label htmlFor="exampleInputEmail1">Vehicle Name</label>
                      <input
                        type="text"
                        className="form-control"
                        id="exampleInputEmail1"
                        placeholder="Please enter Vehicle Name"
                        value={searchVehicleName}
                        onChange={(e) => {
                          setSearchVehicleName(e.target.value);
                        }}
                      />
                    </div>
                    <div className="form-group col-md-8 col-lg-8">
                      <div className="btn-wrapper justify-content-start cmt-3">
                        <button type="button" className="btn app-btn-primary" onClick={getRemainders}>
                          Search
                        </button>
                        <button
                          type="button"
                          className="btn app-btn-default"
                          onClick={(e) => {
                            setSearchVehicleName('');
                          }}
                        >
                          Reset
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card">
                <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
                  <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
                    Remainders | {remainderList?.length}
                  </h4>
                  <button onClick={handleShowRemainderModal} type="button" className="btn app-btn-primary">
                    Create
                  </button>
                </div>
                <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
                  <div className="row">
                    <div className="col">
                      <Table responsive striped>
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Vehicle Name</th>
                            <th>Document Type</th>
                            <th>Description</th>
                            <th>Status</th>
                            <th>Due Date</th>
                            <th>Supervised By</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {remainderList?.map((request, index) => {
                            return (
                              <tr key={index}>
                                <td>{(currentPage - 1) * TABLE_DEFAULT_LIMIT + (index + 1)}</td>
                                <td>{request.runningVehicleName}</td>
                                <td>{request.docType}</td>
                                <td>{request.description}</td>
                                <td>{request.status}</td>
                                <td>{formatDate(request.dueDate)}</td>
                                <td>{request.supervisedBy}</td>
                                <td className="actions">
                                  <span onClick={(e) => editRemainderRequest(e, request.id)} className="edit-icon">
                                    <EditIcon />
                                  </span>
                                  &nbsp;&nbsp;
                                  <Link to="/" onClick={(e) => handleShowRemainderConfirmModal(e, request.id)}>
                                    <DeleteIcon />
                                  </Link>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </Table>
                      <PaginationInPage
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        totalRecords={totalRecords}
                        TABLE_DEFAULT_LIMIT={TABLE_DEFAULT_LIMIT}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Tab>
            <Tab eventKey="document" title="Documents">
              <div className="card top-card">
                <div className="card-body">
                  <div className="row">
                    <div className="form-group col-md-4 col-lg-4">
                      <label htmlFor="exampleInputEmail1">Vehicle Name</label>
                      <input
                        type="text"
                        className="form-control"
                        id="exampleInputEmail1"
                        placeholder="Please enter Vehicle Name"
                        value={searchVehicleName}
                        onChange={(e) => {
                          setSearchVehicleName(e.target.value);
                        }}
                      />
                    </div>
                    <div className="form-group col-md-8 col-lg-8">
                      <div className="btn-wrapper justify-content-start cmt-3">
                        <button type="button" className="btn app-btn-primary" onClick={getDocuments}>
                          Search
                        </button>
                        <button
                          type="button"
                          className="btn app-btn-default"
                          onClick={(e) => {
                            setSearchVehicleName('');
                          }}
                        >
                          Reset
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card">
                <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
                  <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
                    Documents | {documentList?.length}
                  </h4>
                  <button onClick={handleShowDocumentModal} type="button" className="btn app-btn-primary">
                    Create
                  </button>
                </div>
                <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
                  <div className="row">
                    <div className="col">
                      <Table responsive striped>
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Vehicle Name</th>
                            <th>Document Name</th>
                            <th>Description</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {documentList?.map((request, index) => {
                            return (
                              <tr key={index}>
                                <td>{(currentPage - 1) * TABLE_DEFAULT_LIMIT + (index + 1)}</td>
                                <td>{request.runningVehicleName}</td>
                                <td>{request.documentName}</td>
                                <td>{request.description}</td>
                                <td className="actions">
                                  <span onClick={(e) => editDocumentRequest(e, request.id)} className="edit-icon">
                                    <EditIcon />
                                  </span>
                                  &nbsp;&nbsp;
                                  <Link to="/" onClick={(e) => handleShowDocumentConfirmModal(e, request.id, null)}>
                                    <DeleteIcon />
                                  </Link>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </Table>
                      <PaginationInPage
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        totalRecords={totalRecords}
                        TABLE_DEFAULT_LIMIT={TABLE_DEFAULT_LIMIT}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Tab>
            <Tab eventKey="breakdown" title="Breakdown">
              <div className="card top-card">
                <div className="card-body">
                  <div className="row">
                    <div className="form-group col-md-4 col-lg-4">
                      <label htmlFor="exampleInputEmail1">Vehicle Name</label>
                      <input
                        type="text"
                        className="form-control"
                        id="exampleInputEmail1"
                        placeholder="Please enter Vehicle Name"
                        value={vehicleName}
                        onChange={(e) => {
                          setVehicleName(e.target.value);
                        }}
                      />
                    </div>
                    <div className="form-group col-md-8 col-lg-8">
                      <div className="btn-wrapper justify-content-start cmt-3">
                        <button type="button" className="btn app-btn-primary" onClick={getBreak}>
                          Search
                        </button>
                        <button type="button" className="btn app-btn-default" onClick={() => setVehicleName('')}>
                          Reset
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card">
                <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
                  <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
                    Breakdown | {breakdownList?.length}
                  </h4>
                  <button onClick={handleShowBreakdownModal} type="button" className="btn app-btn-primary">
                    Create
                  </button>
                </div>
                <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
                  <div className="row">
                    <div className="col">
                      <Table responsive striped>
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Vehicle Name</th>
                            <th>Reason</th>
                            <th>Status</th>
                            <th>Break Date</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {breakdownList?.map((request, index) => {
                            return (
                              <tr key={request.id}>
                                <td>{(currentPage - 1) * TABLE_DEFAULT_LIMIT + (index + 1)}</td>
                                <td>{runngingVehicleDetail?.vehicleModelName}</td>
                                <td>{request.reason}</td>
                                <td>{request.status}</td>
                                <td>{formatDate(request.breakDate)}</td>
                                <td className="actions">
                                  <span onClick={(e) => editBreakdownRequest(e, request.id)} className="edit-icon">
                                    <EditIcon />
                                  </span>
                                  &nbsp;&nbsp;
                                  <Link to="/" onClick={(e) => handleBreakdownConfirmModal(e, request.id)}>
                                    <DeleteIcon />
                                  </Link>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </Table>
                      <PaginationInPage
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        totalRecords={totalRecords}
                        TABLE_DEFAULT_LIMIT={TABLE_DEFAULT_LIMIT}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Tab>
            <Tab eventKey="spares" title="Spares">
              <div className="card top-card">
                <div className="card-body">
                  <div className="row">
                    <div className="form-group col-md-4 col-lg-4">
                      <label htmlFor="exampleInputEmail1">Spare Name</label>
                      <input
                        type="text"
                        className="form-control"
                        id="exampleInputEmail1"
                        placeholder="Please enter Spare Name"
                        value={spareName}
                        onChange={(e) => {
                          setSpareName(e.target.value);
                        }}
                      />
                    </div>
                    <div className="form-group col-md-8 col-lg-8">
                      <div className="btn-wrapper justify-content-start cmt-3">
                        <button type="button" className="btn app-btn-primary" onClick={getSpares}>
                          Search
                        </button>
                        <button type="button" className="btn app-btn-default" onClick={() => setSpareName('')}>
                          Reset
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card">
                <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
                  <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
                    Spares | {spareList.length}
                  </h4>
                  <button onClick={handleShowSpareModal} type="button" className="btn app-btn-primary">
                    Create
                  </button>
                </div>
                <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
                  <div className="row">
                    <div className="col">
                      <Table responsive striped>
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Spare Name</th>
                            <th>Quantity</th>
                            <th>Description</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {spareList?.map((request, index) => {
                            return (
                              <tr key={request.id}>
                                <td>{(currentPage - 1) * TABLE_DEFAULT_LIMIT + (index + 1)}</td>
                                <td>{request.spareName}</td>
                                <td>{request.quantity}</td>
                                <td>{request.description}</td>
                                <td className="actions">
                                  <span onClick={(e) => editSpareRequest(e, request.id)} className="edit-icon">
                                    <EditIcon />
                                  </span>
                                  &nbsp;&nbsp;
                                  <Link to="/" onClick={(e) => handleSpareConfirmModal(e, request.id)}>
                                    <DeleteIcon />
                                  </Link>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </Table>
                      <PaginationInPage
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        totalRecords={totalRecords}
                        TABLE_DEFAULT_LIMIT={TABLE_DEFAULT_LIMIT}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Tab>
            <Tab eventKey="spareRequest" title="Spare Request">
              <div className="card top-card">
                <div className="card-body">
                  <div className="row">
                    <div className="form-group col-md-4 col-lg-4">
                      <label htmlFor="exampleInputEmail1">Spare Name</label>
                      <input
                        type="text"
                        className="form-control"
                        id="exampleInputEmail1"
                        value={spareRequestName}
                        placeholder="Please enter Spare Name"
                        onChange={(e) => setSpareRequestName(e.target.value)}
                      />
                    </div>
                    <div className="form-group col-md-8 col-lg-8">
                      <div className="btn-wrapper justify-content-start cmt-3">
                        <button type="button" className="btn app-btn-primary" onClick={getSparesRequest}>
                          Search
                        </button>
                        <button type="button" className="btn app-btn-default" onClick={() => setSpareRequestName('')}>
                          Reset
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card">
                <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
                  <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
                    Spare Request | {spareRequestList.length}
                  </h4>
                  <button onClick={handleShowSpareRequestModal} type="button" className="btn app-btn-primary">
                    Create
                  </button>
                </div>
                <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
                  <div className="row">
                    <div className="col">
                      <Table responsive striped>
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Spare Name</th>
                            <th>Status</th>
                            <th>Quantity</th>
                            <th>Requested By</th>
                            <th>Description</th>
                            <th>Approved By</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {spareRequestList?.map((request, index) => {
                            return (
                              <tr key={request.id}>
                                <td>{(currentPage - 1) * TABLE_DEFAULT_LIMIT + (index + 1)}</td>
                                <td>{request.spareName}</td>
                                <td>{request.status}</td>
                                <td>{request.quantity}</td>
                                <td>{request.requestedBy}</td>
                                <td>{request.description}</td>
                                <td>{request.approvedBy}</td>
                                <td className="actions" style={{ paddingRight: '0px' }}>
                                  <span onClick={(e) => editSpareRequestE(e, request.id)} className="edit-icon">
                                    <EditIcon />
                                  </span>
                                  &nbsp;&nbsp;
                                  <Link to="/" onClick={(e) => handleSpareRequestConfirmModal(e, request.id)}>
                                    <DeleteIcon />
                                  </Link>
                                  {request.status === 'Pending' ? (
                                    <button
                                      type="button"
                                      className="btn app-btn-primary custom-btn-btn"
                                      onClick={(e) => handleSpareRequestApproveModel(e, request.id)}
                                    >
                                      Approve
                                    </button>
                                  ) : (
                                    ''
                                  )}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </Table>
                      <PaginationInPage
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        totalRecords={totalRecords}
                        TABLE_DEFAULT_LIMIT={TABLE_DEFAULT_LIMIT}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Tab>
            <Tab eventKey="resell-scrap" title="Resell / Scrap">
              {!resellScrapInfo ? (
                <button onClick={handleShowResellScrapModal} className="btn btn-danger" type="button">
                  Resell / Scrap this product
                </button>
              ) : (
                <div className="card">
                  <div className="card-body">
                    <Row className="top-row">
                      <div className="col-md-2">
                        <dd className="display-title mb-1">Type</dd>
                        <dt className="display-value">{resellScrapInfo.type}</dt>
                      </div>
                      <div className="col-md-2">
                        <dd className="display-title mb-1">Resell Date</dd>
                        <dt className="display-value">{formatDate(resellScrapInfo.date)}</dt>
                      </div>
                      <div className="col-md-2">
                        <dd className="display-title mb-1">Approved By</dd>
                        <dt className="display-value">{resellScrapInfo.approvedBy}</dt>
                      </div>
                      <div className="col-md-2">
                        <dd className="display-title mb-1">Supervised By</dd>
                        <dt className="display-value">{resellScrapInfo.supervisedBy}</dt>
                      </div>
                      <div className="col-md-2">
                        <dd className="display-title mb-1">Amount</dd>
                        <dt className="display-value">{resellScrapInfo.resellAmount}</dt>
                      </div>
                      <div className="col-md-2">
                        <dd className="display-title mb-1">Reason</dd>
                        <dt className="display-value">{resellScrapInfo.reason}</dt>
                      </div>
                    </Row>
                    <Row className="top-row">
                      <div className="col-md-2">
                        <dd className="display-title mb-1">Buyer</dd>
                        <dt className="display-value">{resellScrapInfo.buyerName}</dt>
                      </div>
                      <div className="col-md-2">
                        <dd className="display-title mb-1">Buyer Contact Person</dd>
                        <dt className="display-value">{resellScrapInfo.buyerCPerson}</dt>
                      </div>
                      <div className="col-md-2">
                        <dd className="display-title mb-1">Buyer Contact</dd>
                        <dt className="display-value">{resellScrapInfo.buyerCNumber}</dt>
                      </div>
                      <div className="col-md-2">
                        <dd className="display-title mb-1">Buyer Email</dd>
                        <dt className="display-value">{resellScrapInfo.buyerEmail}</dt>
                      </div>
                      <div className="col-md-2">
                        <dd className="display-title mb-1">Buyer GST</dd>
                        <dt className="display-value">{resellScrapInfo.buyerGst}</dt>
                      </div>
                    </Row>
                  </div>
                </div>
              )}
            </Tab>
          </Tabs>
        )}
      </div>
      <Modal size="lg" show={showServiceRemainderModal} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header>
          {isView ? (<Modal.Title>View Service</Modal.Title>) : (
            <Modal.Title>{serviceForm.id ? 'Edit Service' : 'Add Service'}</Modal.Title>
          )}
          <button type="button" className="btn-close" aria-label="Close" onClick={handleCloseServiceRemainderModal}></button>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Service Name" className="mb-3">
                  <Form.Control
                    disabled={isView}
                    onChange={handleChange}
                    value={serviceForm.serviceName}
                    className="input"
                    name="serviceName"
                    type="text"
                    placeholder="Service Name"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Purpose" className="mb-3">
                  <Form.Control
                    disabled={isView}
                    onChange={handleChange}
                    value={serviceForm.description}
                    className="input"
                    name="description"
                    type="text"
                    placeholder="Purpose"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Due Date" className="mb-3">
                  <Form.Control
                    disabled={isView}
                    onChange={handleChange}
                    value={serviceForm.dueDate}
                    className="input"
                    name="dueDate"
                    type="date"
                    placeholder="Due Date"
                    required
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Row className="mb-4">
              <Col xs={4}>
                <FloatingLabel controlId="floatingSelect" label="Type">
                  <Form.Select
                    disabled={isView}
                    value={serviceForm.serviceType}
                    onChange={handleSelect}
                    name="serviceType"
                    aria-label="Floating label select example"
                    required
                  >
                    <option>Select Service Type</option>
                    <option value="free">Free</option>
                    <option value="paid">Paid</option>
                  </Form.Select>
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingSelect" label="Status">
                  <Form.Select
                    disabled={isView}
                    value={serviceForm.serviceStatus}
                    onChange={handleSelect}
                    name="serviceStatus"
                    aria-label="Floating label select example"
                    required
                  >
                    <option>Select Service Status</option>
                    <option value="pending">Pending</option>
                    <option value="completed">Completed</option>
                  </Form.Select>
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Last Service Date" className="mb-3">
                  <Form.Control
                    disabled={isView}
                    onChange={handleChange}
                    value={moment(serviceForm.lServiceDate).format('YYYY-MM-DD')}
                    className="input"
                    name="lServiceDate"
                    type="date"
                    placeholder="Last Service Date"
                    required
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Row className="mb-4">
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Last Service Kms" className="mb-3">
                  <Form.Control
                    disabled={isView}
                    onChange={handleChange}
                    value={serviceForm.lastServiceKm}
                    className="input"
                    name="lastServiceKm"
                    type="text"
                    placeholder="Last Service Kms"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Current Kms" className="mb-3">
                  <Form.Control
                    disabled={isView}
                    onChange={handleChange}
                    value={serviceForm.currentKm}
                    className="input"
                    name="currentKm"
                    type="text"
                    placeholder="Current Kms"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Total Kms" className="mb-3">
                  <Form.Control
                    disabled={isView}
                    value={totalKmsSubtract(serviceForm.currentKm, serviceForm.lastServiceKm)}
                    className="input"
                    name="totalKm"
                    type="text"
                    placeholder="Total Kms"
                    required
                    readOnly
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Showroom Name" className="mb-3">
                  <Form.Control
                    disabled={isView}
                    onChange={handleChange}
                    value={serviceForm.showroomName}
                    className="input"
                    name="showroomName"
                    type="text"
                    placeholder="Showroom Name"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Showroom Address" className="mb-3">
                  <Form.Control
                    disabled={isView}
                    onChange={handleChange}
                    value={serviceForm.showroomAddress}
                    className="input"
                    name="showroomAddress"
                    type="text"
                    placeholder="Showroom Address"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Showroom Contact No." className="mb-3">
                  <Form.Control
                    disabled={isView}
                    onChange={handleChange}
                    value={serviceForm.sContactNo}
                    className="input"
                    name="sContactNo"
                    type="text"
                    placeholder="Showroom Contact No."
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Service Comments" className="mb-3">
                  <Form.Control
                    disabled={isView}
                    onChange={handleChange}
                    value={serviceForm.serviceComments}
                    className="input"
                    name="serviceComments"
                    type="text"
                    placeholder="Service Comments"
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <div className={serviceForm.serviceStatus === 'completed' ? 'service-completion-detail' : 'hidden-service-completion-detail'}>
              <Row className="bottom-content mb-4">
                <Col xs={12}>
                  <Alert.Heading>Service Completion Details</Alert.Heading>
                  <hr />
                </Col>
                <Col xs={4}>
                  <FloatingLabel controlId="floatingInput" label="Serviced Date" className="mb-3">
                    <Form.Control
                      disabled={isView}
                      onChange={handleChange}
                      value={serviceForm.servicedDate}
                      className="input"
                      name="servicedDate"
                      type="date"
                      placeholder="Serviced Date"
                      required
                    />
                  </FloatingLabel>
                </Col>
                <Col xs={4}>
                  <FloatingLabel controlId="floatingInput" label="Material Cost" className="mb-3">
                    <Form.Control
                      disabled={isView}
                      onChange={handleChange}
                      value={serviceForm.mCost}
                      className="input"
                      name="mCost"
                      type="text"
                      placeholder="Material Cost"
                    />
                  </FloatingLabel>
                </Col>
                <Col xs={4}>
                  <FloatingLabel controlId="floatingInput" label="Supervised By" className="mb-3">
                    <Form.Control
                      disabled={isView}
                      onChange={handleChange}
                      value={serviceForm.supervisedBy}
                      className="input"
                      name="supervisedBy"
                      type="text"
                      placeholder="Supervised By"
                      required
                    />
                  </FloatingLabel>
                </Col>
                <Col xs={4}>
                  <FloatingLabel controlId="floatingInput" label="Labour Cost" className="mb-3">
                    <Form.Control
                      disabled={isView}
                      onChange={handleChange}
                      value={serviceForm.labourCost}
                      className="input"
                      name="labourCost"
                      type="text"
                      placeholder="Labour Cost"
                      required
                    />
                  </FloatingLabel>
                </Col>
                <Col xs={4}>
                  <FloatingLabel controlId="floatingInput" label="Total Cost" className="mb-3">
                    <Form.Control
                      disabled={isView}
                      onChange={handleChange}
                      value={serviceForm.totalCost}
                      className="input"
                      name="totalCost"
                      type="text"
                      placeholder="Total Cost"
                      required
                    />
                  </FloatingLabel>
                </Col>
              </Row>
              <Row className="bottom-content">
                <Col xs={12}>
                  <Alert.Heading>Documents</Alert.Heading>
                  <hr />
                </Col>
                <Col xs={4}>
                  <Form.Group controlId="formFile" className="mb-3 images-box">
                    <Form.Label>Document 1</Form.Label>
                    <Form.Control onChange={onChangeDocument1} type="file" name="document1" aria-required="false" disabled={isView} />
                    <p className="file-name">{serviceForm?.documentName1}
                      &nbsp;&nbsp;
                      {isView && serviceForm.document1 && <a
                        href={`${process.env.REACT_APP_BASE_URL}/file/download?filePath=${serviceForm?.document1}`}
                      >
                        <DownloadIcon />
                      </a>}</p>
                  </Form.Group>
                </Col>
                <Col xs={4}>
                  <Form.Group controlId="formFile" className="mb-3 images-box">
                    <Form.Label>Document 2</Form.Label>
                    <Form.Control onChange={onChangeDocument2} type="file" name="document2" aria-required="false" disabled={isView} />
                    <p className="file-name">{serviceForm?.documentName2}
                      &nbsp;&nbsp;
                      {isView && serviceForm.document2 && <a
                        href={`${process.env.REACT_APP_BASE_URL}/file/download?filePath=${serviceForm?.document2}`}
                      >
                        <DownloadIcon />
                      </a>}
                    </p>
                  </Form.Group>
                </Col>
                <Col xs={4}>
                  <Form.Group controlId="formFile" className="mb-3 images-box">
                    <Form.Label>Document 3</Form.Label>
                    <Form.Control onChange={onChangeDocument3} type="file" name="document3" aria-required="false" disabled={isView} />
                    <p className="file-name">{serviceForm?.documentName3}
                      &nbsp;&nbsp;
                      {isView && serviceForm.document3 && <a
                        href={`${process.env.REACT_APP_BASE_URL}/file/download?filePath=${serviceForm?.document3}`}
                      >
                        <DownloadIcon />
                      </a>}
                    </p>
                  </Form.Group>
                </Col>
                <Col xs={4}>
                  <Form.Group controlId="formFile" className="mb-3 images-box">
                    <Form.Label>Document 4</Form.Label>
                    <Form.Control onChange={onChangeDocument4} type="file" name="document4" aria-required="false" disabled={isView} />
                    <p className="file-name">{serviceForm?.documentName4}
                      &nbsp;&nbsp;
                      {isView && serviceForm.document4 && <a
                        href={`${process.env.REACT_APP_BASE_URL}/file/download?filePath=${serviceForm?.document4}`}
                      >
                        <DownloadIcon />
                      </a>}
                    </p>
                  </Form.Group>
                </Col>
              </Row>
            </div>
            {!isView && (
              <Button onClick={handleSubmit} type="submit" className="add-request-btn mt-4 mb-3 justify-content-center">
                {serviceForm.id ? 'Update' : 'Add'}
              </Button>
            )}
          </Form>
        </Modal.Body>
      </Modal>
      {/* Add/Edit Reminder Modal */}
      <Modal size="lg" show={showRemainderModal} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header>
          <Modal.Title>{remainderForm.id ? 'Edit Remainder' : 'Add Remainder'}</Modal.Title>
          <button type="button" className="btn-close" aria-label="Close" onClick={handleCloseRemainderModal}></button>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
              <Col xs={4}>
                <FloatingLabel controlId="floatingSelect" label="Document">
                  <Form.Select
                    value={remainderForm.docType}
                    onChange={handleRemainderSelect}
                    name="docType"
                    aria-label="Floating label select example"
                    required
                  >
                    <option>Select Document</option>
                    <option value="Insurance">Insurance</option>
                    <option value="FC">FC</option>
                    <option value="RC">RC</option>
                    <option value="Emission">Emission</option>
                  </Form.Select>
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Description" className="mb-3">
                  <Form.Control
                    onChange={handleRemainderChange}
                    value={remainderForm.description}
                    className="input"
                    name="description"
                    type="text"
                    placeholder="Description"
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Due Date" className="mb-3">
                  <Form.Control
                    onChange={handleRemainderChange}
                    value={remainderForm.dueDate}
                    className="input"
                    name="dueDate"
                    type="date"
                    placeholder="Due Date"
                    required
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Row className="mb-4">
              <Col xs={4}>
                <FloatingLabel controlId="floatingSelect" label="Status">
                  <Form.Select
                    value={remainderForm.status}
                    onChange={handleRemainderSelect}
                    name="status"
                    aria-label="Floating label select example"
                    required
                  >
                    <option>Select Remainder Status</option>
                    <option value="Pending">Pending</option>
                    <option value="Completed">Completed</option>
                  </Form.Select>
                </FloatingLabel>
              </Col>
            </Row>
            <div className={remainderForm.status === 'Completed' ? 'service-completion-detail' : 'hidden-service-completion-detail'}>
              <Row className="bottom-content mb-4">
                <Col xs={12}>
                  <Alert.Heading>Remainder Completion Details</Alert.Heading>
                  <hr />
                </Col>
                <Col xs={4}>
                  <FloatingLabel controlId="floatingInput" label="Supervised By" className="mb-3">
                    <Form.Control
                      onChange={handleRemainderChange}
                      value={remainderForm.supervisedBy}
                      className="input"
                      name="supervisedBy"
                      type="text"
                      placeholder="Supervised By"
                      required
                    />
                  </FloatingLabel>
                </Col>
                <Col xs={4}>
                  <FloatingLabel controlId="floatingInput" label="Completed Date" className="mb-3">
                    <Form.Control
                      onChange={handleRemainderChange}
                      value={remainderForm.completedDate}
                      className="input"
                      name="completedDate"
                      type="date"
                      placeholder="Completed Date"
                      required
                    />
                  </FloatingLabel>
                </Col>
                <Col xs={4}>
                  <FloatingLabel controlId="floatingInput" label="Total Cost" className="mb-3">
                    <Form.Control
                      onChange={handleRemainderChange}
                      value={remainderForm.totalCost}
                      className="input"
                      name="totalCost"
                      type="text"
                      placeholder="Total Cost"
                      required
                    />
                  </FloatingLabel>
                </Col>
              </Row>
              <Row className="bottom-content">
                <Col xs={12}>
                  <Alert.Heading>Documents</Alert.Heading>
                  <hr />
                </Col>
                <Col xs={4}>
                  <Form.Group controlId="formFile" className="mb-3 images-box">
                    <Form.Label>Document 1</Form.Label>
                    <Form.Control onChange={onChangeRemainderDocument1} type="file" name="document1" aria-required="false" />
                    <p className="file-name">{remainderForm?.documentName1}</p>
                  </Form.Group>
                </Col>
                <Col xs={4}>
                  <Form.Group controlId="formFile" className="mb-3 images-box">
                    <Form.Label>Document 2</Form.Label>
                    <Form.Control onChange={onChangeRemainderDocument2} type="file" name="document2" aria-required="false" />
                    <p className="file-name">{remainderForm?.documentName2}</p>
                  </Form.Group>
                </Col>
              </Row>
            </div>
            <Button onClick={handleRemainderSubmit} type="submit" className="add-request-btn mt-4 mb-3 justify-content-center">
              {remainderForm.id ? 'Update' : 'Add'}
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
      <Modal size="lg" show={showDocumentModal} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header>
          <Modal.Title>{documentForm.id ? 'Edit Document' : 'Add Document'}</Modal.Title>
          <button type="button" className="btn-close" aria-label="Close" onClick={handleCloseDocumentModal}></button>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
              <Col xs={6}>
                <FloatingLabel controlId="floatingInput" label="Name" className="mb-3">
                  <Form.Control
                    onChange={handleDocumentChange}
                    value={documentForm.documentName}
                    className="input"
                    name="documentName"
                    type="text"
                    placeholder="Name"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={6}>
                <FloatingLabel controlId="floatingInput" label="Description" className="mb-3">
                  <Form.Control
                    onChange={handleDocumentChange}
                    value={documentForm.description}
                    className="input"
                    name="description"
                    type="text"
                    placeholder="Description"
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Row className="mb-4">
              <Col xs={4}>
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label>Document 1</Form.Label>
                  <Form.Control onChange={onChangeDocDocument1} type="file" name="document1" aria-required="false" />
                  <p className="file-name">{documentForm?.documentName1}</p>
                </Form.Group>
              </Col>
              <Col xs={4}>
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label>Document 2</Form.Label>
                  <Form.Control onChange={onChangeDocDocument2} type="file" name="document2" aria-required="false" />
                  <p className="file-name">{documentForm?.documentName2}</p>
                </Form.Group>
              </Col>
            </Row>
            <Button onClick={handleDocumentSubmit} type="submit" className="add-request-btn mt-4 mb-3 justify-content-center">
              {documentForm.id ? 'Edit' : 'Add'}
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
      <Modal size="lg" show={showBreakdownModal} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header>
          <Modal.Title>{breakdownForm.id ? 'Edit Breakdown' : 'Add Breakdown'}</Modal.Title>
          <button type="button" className="btn-close" aria-label="Close" onClick={handleCloseBreakdownModal}></button>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Vehicle Name" className="mb-3">
                  <Form.Control
                    value={runngingVehicleDetail?.vehicleModelName}
                    className="input"
                    name="vehicleName"
                    type="text"
                    placeholder="Vehicle Name"
                    required
                    readOnly
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Break Date" className="mb-3">
                  <Form.Control
                    onChange={handleBreakdownChange}
                    value={breakdownForm.breakDate}
                    className="input"
                    name="breakDate"
                    type="date"
                    placeholder="Break Date"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingSelect" label="Status">
                  <Form.Select
                    value={breakdownForm.status}
                    onChange={handleBreakdownSelect}
                    name="status"
                    aria-label="Floating label select example"
                    required
                  >
                    <option>Select Status</option>
                    <option value="pending">Pending</option>
                    <option value="repaired">Repaired</option>
                  </Form.Select>
                </FloatingLabel>
              </Col>
            </Row>
            <Row className="mb-4">
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Reason" className="mb-3">
                  <Form.Control
                    value={breakdownForm.reason}
                    onChange={handleBreakdownChange}
                    className="input"
                    name="reason"
                    type="text"
                    placeholder="Reason"
                    required
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Row className="bottom-content mb-4">
              <Col xs={12}>
                <Alert.Heading>Breakdown Document</Alert.Heading>
                <hr />
              </Col>
              <Col xs={4}>
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label>Document 1</Form.Label>
                  <Form.Control
                    onChange={onChangeBreakDocument}
                    data-filename="documentName1"
                    type="file"
                    name="document1"
                    aria-required="false"
                  />
                  <p className="file-name">{breakdownForm?.documentName1}</p>
                </Form.Group>
              </Col>
              <Col xs={4}>
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label>Document 2</Form.Label>
                  <Form.Control
                    onChange={onChangeBreakDocument}
                    data-filename="documentName2"
                    type="file"
                    name="document2"
                    aria-required="false"
                  />
                  <p className="file-name">{breakdownForm?.documentName2}</p>
                </Form.Group>
              </Col>
              <Col xs={4}>
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label>Document 3</Form.Label>
                  <Form.Control
                    onChange={onChangeBreakDocument}
                    data-filename="documentName3"
                    type="file"
                    name="document3"
                    aria-required="false"
                  />
                  <p className="file-name">{breakdownForm?.documentName3}</p>
                </Form.Group>
              </Col>
            </Row>
            <div className={breakdownForm.status === 'repaired' ? 'service-completion-detail' : 'hidden-service-completion-detail'}>
              <Row className="bottom-content mb-4">
                <Col xs={12}>
                  <Alert.Heading>Breakdown Repaired Details</Alert.Heading>
                  <hr />
                </Col>
                <Col xs={4}>
                  <FloatingLabel controlId="floatingInput" label="Reference Name" className="mb-3">
                    <Form.Control
                      onChange={handleBreakdownChange}
                      value={breakdownForm.referenceName}
                      className="input"
                      name="referenceName"
                      type="text"
                      placeholder="Reference Name"
                      required
                    />
                  </FloatingLabel>
                </Col>
                <Col xs={4}>
                  <FloatingLabel controlId="floatingInput" label="Reference Number" className="mb-3">
                    <Form.Control
                      onChange={handleBreakdownChange}
                      value={breakdownForm.referenceNumber}
                      className="input"
                      name="referenceNumber"
                      type="text"
                      placeholder="Reference Number."
                      required
                    />
                  </FloatingLabel>
                </Col>
                <Col xs={4}>
                  <FloatingLabel controlId="floatingInput" label="Serviced Date" className="mb-3">
                    <Form.Control
                      onChange={handleBreakdownChange}
                      value={breakdownForm.servicedDate}
                      className="input"
                      name="servicedDate"
                      type="date"
                      placeholder="Serviced Date"
                      required
                    />
                  </FloatingLabel>
                </Col>
                <Col xs={4}>
                  <FloatingLabel controlId="floatingInput" label="Service Comments" className="mb-3">
                    <Form.Control
                      onChange={handleBreakdownChange}
                      value={breakdownForm.serviceComments}
                      className="input"
                      name="serviceComments"
                      type="text"
                      placeholder="Service Comments"
                    />
                  </FloatingLabel>
                </Col>
                <Col xs={4}>
                  <FloatingLabel controlId="floatingInput" label="Material Cost" className="mb-3">
                    <Form.Control
                      onChange={handleBreakdownChange}
                      value={breakdownForm.mCost}
                      className="input"
                      name="mCost"
                      type="text"
                      placeholder="Material Cost"
                    />
                  </FloatingLabel>
                </Col>
                <Col xs={4}>
                  <FloatingLabel controlId="floatingInput" label="Supervised By" className="mb-3">
                    <Form.Control
                      onChange={handleBreakdownChange}
                      value={breakdownForm.supervisedBy}
                      className="input"
                      name="supervisedBy"
                      type="text"
                      placeholder="Supervised By"
                      required
                    />
                  </FloatingLabel>
                </Col>
                <Col xs={4}>
                  <FloatingLabel controlId="floatingInput" label="Labour Cost" className="mb-3">
                    <Form.Control
                      onChange={handleBreakdownChange}
                      value={breakdownForm.labourCost}
                      className="input"
                      name="labourCost"
                      type="text"
                      placeholder="Labour Cost"
                      required
                    />
                  </FloatingLabel>
                </Col>
              </Row>
              <Row className="bottom-content">
                <Col xs={12}>
                  <Alert.Heading>Documents</Alert.Heading>
                  <hr />
                </Col>
                <Col xs={4}>
                  <Form.Group controlId="formFile" className="mb-3 images-box">
                    <Form.Label>Document 4</Form.Label>
                    <Form.Control
                      onChange={onChangeBreakDocument}
                      data-filename="documentName4"
                      type="file"
                      name="document4"
                      aria-required="false"
                    />
                    <p className="file-name">{breakdownForm?.documentName4}</p>
                  </Form.Group>
                </Col>
                <Col xs={4}>
                  <Form.Group controlId="formFile" className="mb-3 images-box">
                    <Form.Label>Document 5</Form.Label>
                    <Form.Control
                      onChange={onChangeBreakDocument}
                      data-filename="documentName5"
                      type="file"
                      name="document5"
                      aria-required="false"
                    />
                    <p className="file-name">{breakdownForm?.documentName5}</p>
                  </Form.Group>
                </Col>
                <Col xs={4}>
                  <Form.Group controlId="formFile" className="mb-3 images-box">
                    <Form.Label>Document 6</Form.Label>
                    <Form.Control
                      onChange={onChangeBreakDocument}
                      data-filename="documentName6"
                      type="file"
                      name="document6"
                      aria-required="false"
                    />
                    <p className="file-name">{breakdownForm?.documentName6}</p>
                  </Form.Group>
                </Col>
                <Col xs={4}>
                  <Form.Group controlId="formFile" className="mb-3 images-box">
                    <Form.Label>Document 7</Form.Label>
                    <Form.Control
                      onChange={onChangeBreakDocument}
                      data-filename="documentName7"
                      type="file"
                      name="document7"
                      aria-required="false"
                    />
                    <p className="file-name">{breakdownForm?.documentName7}</p>
                  </Form.Group>
                </Col>
                <Col xs={4}>
                  <Form.Group controlId="formFile" className="mb-3 images-box">
                    <Form.Label>Document 8</Form.Label>
                    <Form.Control
                      onChange={onChangeBreakDocument}
                      data-filename="documentName8"
                      type="file"
                      name="document8"
                      aria-required="false"
                    />
                    <p className="file-name">{breakdownForm?.documentName8}</p>
                  </Form.Group>
                </Col>
                <Col xs={4}>
                  <Form.Group controlId="formFile" className="mb-3 images-box">
                    <Form.Label>Document 9</Form.Label>
                    <Form.Control
                      onChange={onChangeBreakDocument}
                      data-filename="documentName9"
                      type="file"
                      name="document9"
                      aria-required="false"
                    />
                    <p className="file-name">{breakdownForm?.documentName9}</p>
                  </Form.Group>
                </Col>
                <Col xs={4}>
                  <Form.Group controlId="formFile" className="mb-3 images-box">
                    <Form.Label>Document 10</Form.Label>
                    <Form.Control
                      onChange={onChangeBreakDocument}
                      data-filename="documentName10"
                      type="file"
                      name="document10"
                      aria-required="false"
                    />
                    <p className="file-name">{breakdownForm?.documentName10}</p>
                  </Form.Group>
                </Col>
              </Row>
            </div>
            <Button onClick={handleSubmitBreakdown} type="submit" className="add-request-btn mt-4 mb-3 justify-content-center">
              {breakdownForm.id ? 'Update' : 'Add'}
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
      <Modal size="lg" show={showSpareModal} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header>
          <Modal.Title>{spareForm.id ? 'Edit Spare' : 'Add Spare'}</Modal.Title>
          <button type="button" className="btn-close" aria-label="Close" onClick={handleCloseSpareModal}></button>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Spare Name" className="mb-3">
                  <Form.Control
                    onChange={handleSpareChange}
                    value={spareForm.spareName}
                    className="input"
                    name="spareName"
                    type="text"
                    placeholder="Spare Name"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Quantity" className="mb-3">
                  <Form.Control
                    onChange={handleSpareChange}
                    value={spareForm.quantity}
                    className="input"
                    name="quantity"
                    type="text"
                    placeholder="Quantity"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Description" className="mb-3">
                  <Form.Control
                    onChange={handleSpareChange}
                    value={spareForm.description}
                    className="input"
                    name="description"
                    type="text"
                    placeholder="Description"
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Row className="bottom-content mb-4">
              <Col xs={4}>
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label>Document 1</Form.Label>
                  <Form.Control
                    onChange={onChangeSpareDocument}
                    data-filename="documentName1"
                    type="file"
                    name="document1"
                    aria-required="false"
                  />
                  <p className="file-name">{spareForm?.documentName1}</p>
                </Form.Group>
              </Col>
              <Col xs={4}>
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label>Document 2</Form.Label>
                  <Form.Control
                    onChange={onChangeSpareDocument}
                    data-filename="documentName2"
                    type="file"
                    name="document2"
                    aria-required="false"
                  />
                  <p className="file-name">{spareForm?.documentName2}</p>
                </Form.Group>
              </Col>
            </Row>
            <Button onClick={handleSubmitSpare} type="submit" className="add-request-btn mt-4 mb-3 justify-content-center">
              {spareForm.id ? 'Update' : 'Add'}
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
      <Modal size="lg" show={showSpareRequestModal} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header>
          <Modal.Title>{spareRequestForm.id ? 'Edit Spare Request' : 'Add Spare Request'}</Modal.Title>
          <button type="button" className="btn-close" aria-label="Close" onClick={handleCloseSpareRequestModal}></button>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
              <Col xs={4}>
                <FloatingLabel controlId="floatingSelect" label="Spare Type">
                  <Form.Select
                    value={spareRequestForm.spareType}
                    onChange={handleSelectSpare}
                    name="spareType"
                    aria-label="Floating label select example"
                    required
                  >
                    <option>Select Spare Type</option>
                    <option value="Tyre">Tyre</option>
                    <option value="Other">Other</option>
                  </Form.Select>
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Spare Name" className="mb-3">
                  {spareRequestForm.spareType === 'Tyre' ? (
                    <Form.Control
                      onChange={handleSpareRequestChange}
                      value={spareRequestForm.spareName}
                      className="input"
                      name="spareName"
                      type="text"
                      placeholder="Spare Name"
                      readOnly
                      required
                    />
                  ) : (
                    <Form.Control
                      onChange={handleSpareRequestChange}
                      value={spareRequestForm.spareName}
                      className="input"
                      name="spareName"
                      type="text"
                      placeholder="Spare Name"
                      required
                    />
                  )}
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Requested By" className="mb-3">
                  <Form.Control
                    onChange={handleSpareRequestChange}
                    value={spareRequestForm.requestedBy}
                    className="input"
                    name="requestedBy"
                    type="text"
                    placeholder="Requested By"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Quantity" className="mb-3">
                  <Form.Control
                    onChange={handleSpareRequestChange}
                    value={spareRequestForm.quantity}
                    className="input"
                    name="quantity"
                    type="text"
                    placeholder="Quantity"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Description" className="mb-3">
                  <Form.Control
                    onChange={handleSpareRequestChange}
                    value={spareRequestForm.description}
                    className="input"
                    name="description"
                    type="text"
                    placeholder="Description"
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Button onClick={handleSubmitSpareRequest} type="submit" className="add-request-btn mt-4 mb-3 justify-content-center">
              {spareRequestForm.id ? 'Edit' : 'Add'}
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
      <Modal size="lg" show={showResellScrapModal} backdrop="static" keyboard={false} className="request-modal PQ">
        <Modal.Header>
          <Modal.Title>Resell / Scrap Vehicle</Modal.Title>
          <button type="button" className="btn-close" aria-label="Close" onClick={handleCloseResellScrapModal}></button>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row className="mb-3">
              <Col xs={4}>
                <FloatingLabel controlId="floatingSelect" label="Type">
                  <Form.Select
                    value={resellScrapForm.type}
                    onChange={handleResellScrapSelect}
                    name="type"
                    aria-label="Floating label select example"
                    required
                  >
                    <option>Select Type</option>
                    <option value="resell">Resell</option>
                    <option value="scrap">Scrap</option>
                  </Form.Select>
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Date" className="mb-3">
                  <Form.Control
                    onChange={handleChangeScrap}
                    value={resellScrapForm.date}
                    className="input"
                    name="date"
                    type="date"
                    placeholder="Date"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Buyer Name" className="mb-3">
                  <Form.Control
                    onChange={handleChangeScrap}
                    value={resellScrapForm.buyerName}
                    className="input"
                    name="buyerName"
                    type="text"
                    placeholder="Buyer Name"
                    required
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Buyer Contact Number" className="mb-3">
                  <Form.Control
                    onChange={handleChangeScrap}
                    value={resellScrapForm.buyerCNumber}
                    className="input"
                    name="buyerCNumber"
                    type="text"
                    placeholder="Buyer Contact Number"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Buyer Email" className="mb-3">
                  <Form.Control
                    onChange={handleChangeScrap}
                    value={resellScrapForm.buyerEmail}
                    className="input"
                    name="buyerEmail"
                    type="text"
                    placeholder="Buyer Email"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Buyer Contact Person" className="mb-3">
                  <Form.Control
                    onChange={handleChangeScrap}
                    value={resellScrapForm.buyerCPerson}
                    className="input"
                    name="buyerCPerson"
                    type="text"
                    placeholder="Buyer Contact Person"
                    required
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Buyer GST" className="mb-3">
                  <Form.Control
                    onChange={handleChangeScrap}
                    value={resellScrapForm.buyerGst}
                    className="input"
                    name="buyerGst"
                    type="text"
                    placeholder="Buyer GST"
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Resell Amount" className="mb-3">
                  <Form.Control
                    onChange={handleChangeScrap}
                    value={resellScrapForm.resellAmount}
                    className="input"
                    name="resellAmount"
                    type="text"
                    placeholder="Resell Amount"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Reason" className="mb-3">
                  <Form.Control
                    onChange={handleChangeScrap}
                    value={resellScrapForm.reason}
                    className="input"
                    name="reason"
                    type="text"
                    placeholder="Reason"
                    required
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Approved By" className="mb-3">
                  <Form.Control
                    onChange={handleChangeScrap}
                    value={resellScrapForm.approvedBy}
                    className="input"
                    name="approvedBy"
                    type="text"
                    placeholder="Approved By"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Supervised By" className="mb-3">
                  <Form.Control
                    onChange={handleChangeScrap}
                    value={resellScrapForm.supervisedBy}
                    className="input"
                    name="supervisedBy"
                    type="text"
                    placeholder="Supervised By"
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Row className="bottom-content mb-4">
              <Col xs={12}>
                <Alert.Heading>Documents</Alert.Heading>
                <hr />
              </Col>
              <Col xs={4}>
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label>Document 1</Form.Label>
                  <Form.Control
                    onChange={onChangeResellScrapDocument}
                    data-filename="documentName1"
                    type="file"
                    name="document1"
                    aria-required="false"
                  />
                  <p className="file-name">{resellScrapForm.documentName1}</p>
                </Form.Group>
              </Col>
              <Col xs={4}>
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label>Document 2</Form.Label>
                  <Form.Control
                    onChange={onChangeResellScrapDocument}
                    data-filename="documentName2"
                    type="file"
                    name="document2"
                    aria-required="false"
                  />
                  <p className="file-name">{resellScrapForm.documentName2}</p>
                </Form.Group>
              </Col>
              <Col xs={4}>
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label>Document 3</Form.Label>
                  <Form.Control
                    onChange={onChangeResellScrapDocument}
                    data-filename="documentName3"
                    type="file"
                    name="document3"
                    aria-required="false"
                  />
                  <p className="file-name">{resellScrapForm.documentName3}</p>
                </Form.Group>
              </Col>
            </Row>
            <Button onClick={handleSubmitResellScrap} type="submit" className="add-request-btn mt-4 mb-3 justify-content-center">
              Add
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
      <Modal size="lg" show={showSpareRequestApproveModal} backdrop="static" keyboard={false} className="request-modal PQ">
        <Modal.Header>
          <Modal.Title>Spare Request Approve</Modal.Title>
          <button type="button" className="btn-close" aria-label="Close" onClick={handleCloseSpareRequestApproveModal}></button>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row className="mb-3">
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Approved By" className="mb-3">
                  <Form.Control
                    onChange={handleApproveChange}
                    value={spareRequestForm.approvedBy}
                    className="input"
                    name="approvedBy"
                    type="text"
                    placeholder="Approved By"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Comment" className="mb-3">
                  <Form.Control
                    onChange={handleApproveChange}
                    value={spareRequestForm.comment}
                    className="input"
                    name="comment"
                    type="text"
                    placeholder="Comment"
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Button onClick={handleSpareReqApproveSubmit} type="submit" className="add-request-btn mt-4 mb-3 justify-content-center">
              Add
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
      <Modal size="sm" show={showConfirmModel} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header className="bg-danger text-light py-2">
          <Modal.Title>Delete Service</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex justify-content-start">
            <img src={AlertIcon} alt="Alert" />
            <p className="ps-3 mb-0">Are you sure? Action cannot be undone.</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="btn-wrapper">
            <button onClick={handleCloseConfirmModal} className="btn app-btn-default btn-sm">
              Cancel
            </button>
            <button onClick={(e) => handleRemove(e, idToDeleted)} className="btn app-btn-danger btn-sm">
              Delete
            </button>
          </div>
        </Modal.Footer>
      </Modal>
      <Modal size="sm" show={showConfirmRemainderModel} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header className="bg-danger text-light py-2">
          <Modal.Title>Delete Remainder</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex justify-content-start">
            <img src={AlertIcon} alt="Alert" />
            <p className="ps-3 mb-0">Are you sure? Action cannot be undone.</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="btn-wrapper">
            <button onClick={handleCloseConfirmRemainderModal} className="btn app-btn-default btn-sm">
              Cancel
            </button>
            <button onClick={(e) => handleRemainderRemove(e, idToDeleted)} className="btn app-btn-danger btn-sm">
              Delete
            </button>
          </div>
        </Modal.Footer>
      </Modal>
      <Modal size="sm" show={showConfirmDocumentModel} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header className="bg-danger text-light py-2">
          <Modal.Title>Delete Document</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex justify-content-start">
            <img src={AlertIcon} alt="Alert" />
            <p className="ps-3 mb-0">Are you sure? Action cannot be undone.</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="btn-wrapper">
            <button onClick={handleCloseConfirmDocumentModal} className="btn app-btn-default btn-sm">
              Cancel
            </button>
            <button onClick={(e) => handleDocumentRemove(e, idToDeleted, docToDeleted)} className="btn app-btn-danger btn-sm">
              Delete
            </button>
          </div>
        </Modal.Footer>
      </Modal>
      <Modal size="sm" show={breakdownShowConfirmModel} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header className="bg-danger text-light py-2">
          <Modal.Title>Delete Breakdown</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex justify-content-start">
            <img src={AlertIcon} alt="Alert" />
            <p className="ps-3 mb-0">Are you sure? Action cannot be undone.</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="btn-wrapper">
            <button onClick={handleCloseBreakdownConfirmModal} className="btn app-btn-default btn-sm">
              Cancel
            </button>
            <button onClick={(e) => handleRemoveBreakdown(e, idToDeleted)} className="btn app-btn-danger btn-sm">
              Delete
            </button>
          </div>
        </Modal.Footer>
      </Modal>
      <Modal size="sm" show={spareShowConfirmModel} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header className="bg-danger text-light py-2">
          <Modal.Title>Delete Spare</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex justify-content-start">
            <img src={AlertIcon} alt="Alert" />
            <p className="ps-3 mb-0">Are you sure? Action cannot be undone.</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="btn-wrapper">
            <button onClick={handleCloseSpareConfirmModal} className="btn app-btn-default btn-sm">
              Cancel
            </button>
            <button onClick={(e) => handleRemoveSpare(e, idToDeleted)} className="btn app-btn-danger btn-sm">
              Delete
            </button>
          </div>
        </Modal.Footer>
      </Modal>
      <Modal size="sm" show={spareShowRequestConfirmModel} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header className="bg-danger text-light py-2">
          <Modal.Title>Delete Spare Request</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex justify-content-start">
            <img src={AlertIcon} alt="Alert" />
            <p className="ps-3 mb-0">Are you sure? Action cannot be undone.</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="btn-wrapper">
            <button onClick={handleCloseSpareRequestConfirmModal} className="btn app-btn-default btn-sm">
              Cancel
            </button>
            <button onClick={(e) => handleRemoveSpareRequest(e, idToDeleted)} className="btn app-btn-danger btn-sm">
              Delete
            </button>
          </div>
        </Modal.Footer>
      </Modal>
      <Modal size="lg" show={show} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header>
          <Modal.Title>Add Vehicle Request</Modal.Title>
          <button type="button" className="btn-close" aria-label="Close" onClick={handleClose}></button>
        </Modal.Header>
        <Modal.Body>
          <Form autoComplete="off" noValidate validated={validated}>
            <Row>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Vehicle Name" className="mb-3">
                  <Form.Control
                    className="input"
                    name="model"
                    value={vehicleForm.model}
                    onChange={handleVehicleChange}
                    type="text"
                    placeholder="name@example.com"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingSelect" label="Vehicle Type">
                  <Form.Select
                    value={vehicleForm.vehicleType}
                    onChange={handleVehicleTypeSelect}
                    name="vehicleType"
                    aria-label="Floating label select example"
                    required
                  >
                    <option>Vehicle Type</option>
                    <option value="Ashok-Leyland">Ashok Leyland</option>
                    <option value="Bolero">Bolero</option>
                    <option value="M-Sup-Carry">M.Sup.Carry</option>
                    <option value="Tata-Intra">Tata Intra</option>
                    <option value="Tata-Megha">Tata Megha</option>
                    <option value="Tata-Ace">Tata Ace</option>
                    <option value="Others">Others</option>
                  </Form.Select>
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Requested By" className="mb-3">
                  <Form.Control
                    className="input"
                    name="requestedBy"
                    value={vehicleForm.requestedBy}
                    onChange={handleVehicleChange}
                    type="text"
                    placeholder="name@example.com"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Initiated By" className="mb-3">
                  <Form.Control
                    className="input"
                    name="initiatedBy"
                    value={vehicleForm.initiatedBy}
                    onChange={handleVehicleChange}
                    type="text"
                    placeholder="name@example.com"
                    required
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Row className="mb-4">
              <Col xs={4} className="requested-date">
                <FloatingLabel controlId="floatingInput" label="Requested Date" className="mb-3">
                  <Form.Control
                    className="input"
                    name="requestedDate"
                    value={vehicleForm.requestedDate}
                    onChange={handleVehicleChange}
                    type="date"
                    placeholder="name@example.com"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={8}>
                <FloatingLabel controlId="floatingInput" label="Reason" className="mb-3">
                  <Form.Control
                    className="input"
                    name="reason"
                    value={vehicleForm.reason}
                    onChange={handleVehicleChange}
                    type="text"
                    placeholder="name@example.com"
                    required
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Row className="bottom-content">
              <Col xs={12}>
                <Alert.Heading>Documents</Alert.Heading>
                <hr />
              </Col>
              <Col xs={6}>
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label>Document 1</Form.Label>
                  <Form.Control onChange={onChangeDocumentOne} type="file" name="file" aria-required="false" />
                </Form.Group>
              </Col>
              <Col xs={6}>
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label>Document 2</Form.Label>
                  <Form.Control onChange={onChangeDocumentTwo} type="file" name="file2" aria-required="false" />
                </Form.Group>
              </Col>
            </Row>
            <Button type="submit" onClick={handleVehicleSubmit} className="add-request-btn mt-4 mb-3">
              Add Request
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
      <Modal size="lg" show={showPurchaseModal} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header>
          <Modal.Title>Add Purchase Order</Modal.Title>
          <button type="button" className="btn-close" aria-label="Close" onClick={handleCloseModal}></button>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Purchase Number" className="mb-3">
                  <Form.Control
                    autocomplete="off"
                    onChange={handleChangePurchaseOrder}
                    value={purchaseOrderForm.purchaseNumber}
                    className="input"
                    name="purchaseNumber"
                    type="text"
                    placeholder="Purchase Number"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Vehicle Name" className="mb-3">
                  <Form.Control
                    autocomplete="off"
                    onChange={handleChangePurchaseOrder}
                    value={purchaseOrderForm.vehicleName}
                    className="input"
                    name="vehicleName"
                    type="text"
                    placeholder="Vehicle Name"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Amount" className="mb-3">
                  <Form.Control
                    autocomplete="off"
                    onChange={handleChangePurchaseOrder}
                    value={purchaseOrderForm.amount}
                    className="input"
                    name="amount"
                    type="text"
                    placeholder="Amount"
                    required
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Row className="mb-4">
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Approved Date" className="mb-3">
                  <Form.Control
                    autocomplete="off"
                    className="input"
                    name="approvedDate"
                    value={purchaseOrderForm.approvedDate}
                    onChange={handleChangePurchaseOrder}
                    type="date"
                    placeholder="Approved Date"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Approved By" className="mb-3">
                  <Form.Control
                    autocomplete="off"
                    onChange={handleChangePurchaseOrder}
                    value={purchaseOrderForm.approvedBy}
                    className="input"
                    name="approvedBy"
                    type="text"
                    placeholder="Name of the Approver"
                    required
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Row className="bottom-content">
              <Col xs={12}>
                <Alert.Heading>PO Documents</Alert.Heading>
                <hr />
              </Col>
              <Col xs={4}>
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label>Document 1</Form.Label>
                  <Form.Control required onChange={onChangePurchaseDocumentOne} type="file" name="file1" aria-required="false" />
                </Form.Group>
              </Col>
              <Col xs={4}>
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label>Document 2</Form.Label>
                  <Form.Control required onChange={onChangePurchaseDocumentTwo} type="file" name="file2" aria-required="false" />
                </Form.Group>
              </Col>
              <Col xs={4}>
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label>Document 3</Form.Label>
                  <Form.Control onChange={onChangePurchaseDocumentThree} type="file" name="file3" aria-required="false" />
                </Form.Group>
              </Col>
            </Row>
            <Button onClick={(e) => handleApprove(e)} type="submit" className="add-request-btn mt-4 mb-3 justify-content-center">
              Add
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
      <Modal size="lg" show={showTransferModal} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header>
          <Modal.Title>Transfer</Modal.Title>
          <button type="button" className="btn-close" aria-label="Close" onClick={handleCloseTransferModal}></button>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Factories" className="mb-3">
                  <Form.Select onChange={handleFactory} name="factory">
                    <option value="">Select Factory</option>
                    {factories
                      .filter((item) => item?.id !== parseInt(runngingVehicleDetail?.factoryId))
                      ?.map((item) => {
                        return (
                          <option key={item?.id} value={item?.id}>
                            {item?.name}
                          </option>
                        );
                      })}
                  </Form.Select>
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Approved by" className="mb-3">
                  <Form.Control
                    onChange={handleTransferChange}
                    autocomplete="off"
                    value={transferValue.approvedBy}
                    className="input"
                    name="approvedBy"
                    type="text"
                    placeholder="Approved by"
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Comment" className="mb-3">
                  <Form.Control
                    onChange={handleTransferChange}
                    autocomplete="off"
                    value={transferValue.comment}
                    className="input"
                    name="comment"
                    type="text"
                    placeholder="Comment"
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Row className="mb-4">
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Supervised By" className="mb-3">
                  <Form.Control
                    onChange={handleTransferChange}
                    autocomplete="off"
                    className="input"
                    name="supervisedBy"
                    value={transferValue.supervisedBy}
                    type="text"
                    placeholder="Supervised By"
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Button onClick={handleTransferSubmit} type="submit" className="add-request-btn mt-4 mb-3 justify-content-center">
              Transfer
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

export default RunningVehicleDetail;
